<template>
<f7-page :page-content="true">
  <r-form
    ref="rform"
    class="page"
    classContent="page-content full-height"
    :itemId="idData"
    @save="onSave"
    @loadItem="loadItem"
    :readonly="readonly"
    :dbAdapter="Factura"
    :documentoAdapter="Documento"
    :defaultData="{inspectores:[], logistica: {}, lineas:[], fechaPedido: new Date(), anyoEjecucion: new Date().getFullYear(), activo: true, adelantoCobro: false}"
    :beforeSave="beforeSave"
  >
    <!-- Top Navbar -->
    <template v-slot:before="{rform}">
      <f7-navbar>
        <f7-nav-left>
          <f7-link @click.stop="$f7router.back()">&lt; {{ $t('atras') }}</f7-link>
          <f7-button v-if="rform.canShowHistory" class="btn-historico" icon-f7="square_pencil" @click="rform.getHistory()"> Ver Histórico </f7-button>
        </f7-nav-left>
        <f7-nav-title v-roles="['ADMIN','ADMINISTRACION', 'DIRECTOR']" v-if="idData && !readonly" sliding>{{$t('facturas.editar')}}</f7-nav-title>
        <f7-nav-title v-else-if="idData" sliding>{{rform.formData.tipo == 'ABONO' ? $t('facturas.abono') : (rform.formData.tipo == 'FACTURA' ? $t('facturas.factura'):'') }}</f7-nav-title>
        <f7-nav-title v-else sliding>{{$t('facturas.nuevo')}}</f7-nav-title>
        <f7-nav-right>
          <f7-button
            v-if="!readonly"
            fill
            icon-f7="floppy_disk"
            text="Guardar"
            class="display-flex"
            @click="rform.saveItem()"
          ></f7-button>
          <div slot="right" v-roles="['ADMIN','ADMINISTRACION']" v-if="idData && readonly">
            <div class="menu-item menu-item-dropdown bg-color-primary">
              <div class="menu-item-content"><i class="f7-icons">ellipsis_vertical</i></div>
              <div class="menu-dropdown menu-dropdown-right bg-color-primary">
                <div class="menu-dropdown-content bg-color-primary text-align-right">
                  <div class="menu-dropdown-item menu-close pointer" @click="readonly=false" style="color: red;" v-roles="['ADMIN','ADMINISTRACION']">{{$t('facturas.editar')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" @click="crearTareaFactura()" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.numero">Crear Tarea</div>
                  <div class="menu-dropdown-item menu-close pointer" @click="crearOportunidadFactura()" style="color: gray;" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.numero" v-noroles="['ENAC', 'PRODUCCION']">Crear Oportunidad</div>
                  <div class="menu-dropdown-item menu-close pointer" @click="abrirEnvioEmail([{id: $refs.rform.formData.id}])">Enviar Email</div>
                  <div class="menu-dropdown-divider"></div>
                  <div class="menu-dropdown-item menu-close pointer" @click="descargarFactura()" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.documentoFactura">Descargar Documento</div>
                  <div class="menu-dropdown-item menu-close pointer" @click="seleccionarDocumentoFactura()">Seleccionar Documento</div>
                  <div v-roles="['ADMIN', 'ADMINISTRACION']" v-if="rform && rform.formData">
                    <div class="menu-dropdown-divider"></div>
                    <div class="menu-dropdown-item menu-close pointer text-color-yellow" v-if="rform.formData.bcId" @click="verEnBC(rform.formData.bcId)">{{ $t('pedidos.verEnBC') }}</div>
                    <div class="menu-dropdown-divider"></div>
                  </div>
                  <div v-roles="['ADMIN', 'ADMINISTRACION']" v-if="rform && rform.formData">
                    <div class="menu-dropdown-divider"></div>
                    <div class="menu-dropdown-item menu-close pointer text-color-red" @click="marcarCobrada()">Marcar como cobrada</div>
                    <div class="menu-dropdown-divider"></div>
                  </div>
                  <!-- <div class="menu-dropdown-divider"></div> -->
                  <!-- <div class="menu-dropdown-item menu-close pointer text-color-red" @click="cancelarFactura">{{$t('facturas.cancelar')}}</div> -->
                </div>
              </div>
            </div>
          </div>
        </f7-nav-right>
      </f7-navbar>
    </template>
    <!-- Tabs -->
    <template v-slot:default="{rform}">
      <f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
        <div name="Datos Generales">
          <f7-link
            @click="showDetalle = !showDetalle"
            :tooltip="showDetalle ? 'Ocultar Detalle' : 'Mostrar Detalle'"
            :icon-f7="showDetalle ? 'chevron_compact_up' : 'chevron_compact_down'"
            :title="showDetalle ? 'Ocultar Detalle' : 'Mostrar Detalle'"
            style="padding-left: 7px;font-size: 10px;float: right;"
          ></f7-link>
        </div>
        <f7-card-content v-show="showDetalle">
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100" medium="100">
              <f7-row>
                <div class="label-group" :class="{'col-100': !readonly, 'col-75': readonly}">Datos Generales</div>
                <f7-button
                  class="col-20"
                  v-noroles="['ENAC', 'PRODUCCION']"
                  icon-f7="calendar_circle"
                  @click="popupTareaEditable = true; popupTareasOpened = true; lineaFactura = null;"
                  v-if="readonly && id && $refs.rform && $refs.rform.formData && $refs.rform.formData.numero && $refs.rform.formData.tipo == 'FACTURA' "
                >Crear tarea</f7-button>
                <f7-button
                  class="col-20"
                  v-noroles="['ENAC', 'PRODUCCION']"
                  icon-f7="plus_circle"
                  @click="crearOportunidadFactura()"
                  v-if="readonly && id && $refs.rform && $refs.rform.formData && $refs.rform.formData.numero && $refs.rform.formData.tipo == 'FACTURA' "
                >Crear oportunidad</f7-button>
                <r-input
                  v-noroles="['ENAC', 'PRODUCCION']"
                  class="col-100 medium-25"
                  :form="rform"
                  type="check"
                  :name="'activo'"
                  label="Activo"
                ></r-input>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('facturas.numero')"
                  :form="rform"
                  type="text"
                  name="numero"
                  v-if="idData"
                  :readonly="true"
                ></r-input>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  label="DocEntry"
                  :form="rform"
                  type="text"
                  name="docEntry"
                  v-if="idData"
                  v-roles="['ADMIN']"
                  :readonly="true"
                ></r-input>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('facturas.codigo')"
                  :form="rform"
                  type="text"
                  name="codigo"
                  :readonly="true"
                ></r-input>
                <r-autocomplete
                  :dbAdapter="Cliente"
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('pedidos.cliente')"
                  :form="rform"
                  name="cliente"
                  labelProp="codigoNombre"
                  :minLength="3"
                  :shownFields="['razonSocial', 'direcciones', 'direccionDefectoFacturas', 'direccionDefectoEnvio', 'condPago', 'viaPagoDefecto', 'listaPrecios', 'contactos']"
                  :async="true"
                ></r-autocomplete>
                <r-autocomplete
                  v-if="clienteSelected"
                  key="contactoCliente"
                  :ref="'contactoCliente'"
                  :dbAdapter="ContactoCliente"
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('ofertas.contactocliente')"
                  :form="rform"
                  :name="'contactoCliente'"
                  labelProp="alias"
                  infoText="Cree un contacto nuevo para este cliente"
                  @change="changeContacto"
                  :filter="clienteSelected ? {clienteId: rform.formData.cliente.id} : undefined"
                >
                  <f7-link
                    v-if="!rform.formData.contactoCliente"
                    slot="inner-end"
                    popup-open=".popup-contacto"
                    class="input-suffix-btn"
                    icon-f7="plus_app_fill"
                  ></f7-link>
                </r-autocomplete>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('ofertas.emailcontacto')"
                  :form="rform"
                  type="text"
                  name="emailContacto"
                  key="emailContacto"
                ></r-input>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('ofertas.telefono')"
                  :form="rform"
                  type="text"
                  name="telefono"
                  key="telefono"
                ></r-input>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('ofertas.telefonoMovil')"
                  :form="rform"
                  type="text"
                  name="telefonoMovil"
                  key="telefonoMovil"
                ></r-input>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('facturas.estado')" 
                  :form="rform"
                  type="select"
                  name="estado.estado"
                >
                  <option value="ABIERTA">{{$t('facturas.abierta')}}</option>
                  <option value="CERRADA">{{$t('facturas.cerrada')}}</option>
                  <option value="CANCELADA">{{$t('facturas.cancelada')}}</option>
                </r-input>
                <r-autocomplete
                  v-if="idData"
                  :dbAdapter="Empleado"
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('pedidos.empleadoContratacion')"
                  :form="rform"
                  name="contratacion.codEmpleado"
                  labelProp="nombre"
                  idProp="username"
                  idFieldDetail="id"
                  prefixProp="username"
                  :hidden="true"
                ></r-autocomplete>
                <r-autocomplete
                  v-if="idData"
                  :dbAdapter="Empleado"
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('pedidos.usuarioEjecucion')"
                  :form="rform"
                  name="camposUsuario.cpEj"
                  labelProp="nombre"
                  idProp="username"
                  prefixProp="username"
                  idFieldDetail="id"
                  :hidden="true"
                ></r-autocomplete>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('facturas.fechaFactura')"
                  :form="rform"
                  type="datepicker"
                  name="fechaFactura"
                  :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                ></r-input>
                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('facturas.fechaEmision')"
                  :form="rform"
                  type="datepicker"
                  name="fechaEmision"
                  :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                ></r-input>

                <r-input
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('facturas.fechaVencimiento')"
                  :form="rform"
                  type="datepicker"
                  name="fechaVencimiento"
                  :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                ></r-input>

                <r-input
                  v-noroles="['ENAC', 'PRODUCCION']"
                  class="col-100 medium-50"
                  floating-label 
                  :label="$t('pedidos.comentarios')"
                  :form="rform"
                  type="text"
                  name="comentarios"
                ></r-input>
              </f7-row>
            </f7-col>
            <f7-col width="100" medium="100">
              <f7-row no-gap>
                <!-- <div class="label-group col-100 text-color-red">{{$t('pedidos.totales')}}</div> -->
                <f7-list-input
                  class="col-100 medium-15 text-color-red"
                  :readonly="true"
                  floating-label
                  :label="$t('pedidos.subtotal')"
                  type="number"
                  key="facturas.subtotal.con.proveedor"
                  step=".01"
                  :value="getFormatted(rform.formData ? rform.formData.totalSinIVAConTasasConDescuentoConTerceros : 0)"
                ></f7-list-input>
                <f7-list-input
                  class="col-100 medium-10 text-color-red "
                  :readonly="true"
                  floating-label
                  :label="$t('pedidos.totalIVA')"
                  type="number"
                  key="facturas.totalIVA.con.proveedor"
                  step=".01"
                  :value="getFormatted(rform.formData ? rform.formData.totalIva : 0)"
                ></f7-list-input>
                <f7-list-input
                  class="col-100 medium-15 text-color-red"
                  :readonly="true"
                  floating-label
                  :label="$t('pedidos.total')"
                  type="number"
                  key="facturas.total.con.proveedor"
                  step=".01"
                  :value="getFormatted(rform.formData ? rform.formData.totalFactura : 0)"
                ></f7-list-input>
                <f7-list-input
                  class="col-100 medium-15 text-color-red"
                  :readonly="true"
                  floating-label
                  :label="$t('facturas.importeaplicado')"
                  type="number"
                  key="facturas.total.importeaplicado"
                  step=".01"
                  :value="getFormatted(rform.formData ? rform.formData.importeAplicado : 0)"
                ></f7-list-input>
                <f7-list-input
                  class="col-100 medium-15 text-color-red"
                  :readonly="true"
                  floating-label
                  :label="$t('facturas.saldovencido')"
                  type="number"
                  key="facturas.total.saldovencido"
                  step=".01"
                  :value="getFormatted(rform.formData ? rform.formData.saldoVencido : 0)"
                ></f7-list-input>
              </f7-row>
            </f7-col>
          </f7-row>
          <f7-row no-gap class="list list-form no-hairlines datos-cobros" >
            <div class="col-100 cobros-row">
              <f7-row no-gap>
                <f7-list-input
                  class="col-100 medium-15 text-color-red"
                  :readonly="true"
                  floating-label
                  :label="'Cobrado'"
                  type="number"
                  key="facturas.total.cobrado"
                  step=".01"
                  :value="getFormatted(rform.formData ? rform.formData.totalCobradoConIVA : 0)"
                ></f7-list-input>

                <div class="col-100 medium-15">
                  <div class="item-input-wrap">
                    <label class="item-floating-label">{{ $t('facturas.ultimoCobro') }}</label>
                    <div class="display-flex" style="align-items:center; gap:8px;">
                      <div style="min-width:120px">{{ formatLastCobroFecha() }}</div>
                      <div style="min-width:90px">{{ formatLastCobroImporte() }}</div>
                      <f7-link icon-f7="list_bullet" @click="popupCobrosOpened = true" v-tooltip="'Histórico de cobros'" v-if="hasCobros()" class="input-suffix-btn"></f7-link>
                    </div>
                  </div>
                </div>

                
                <r-autocomplete
                  :dbAdapter="Empleado"
                  class="col-100 medium-20"
                  floating-label
                  :label="$t('facturas.responsableGestionCobro')"
                  :form="rform"
                  name="responsableGestionCobro.usernameResponsable"
                  labelProp="nombre"
                  idProp="username"
                  prefixProp="username"
                  idFieldDetail="id"
                  :decorationConfig="{
                    icon: 'rectangle_on_rectangle_angled',
                    color: 'blue',
                    tooltip: 'Histórico de responsables',
                    action: mostrarHistoricoResponsablesGestionCobro
                  }"
                  @loaded="guardarNombresEmpleados"
                ></r-autocomplete>
                <div v-if="readonly" class="col-100 medium-20">
                  <div class="item-input-wrap">
                    <label class="item-floating-label">{{ $t('facturas.estadoGestionCobro') }}</label><br/>
                    <r-input
                      type="badge"
                      name="estadoGestionCobro.estado"
                      :readonly="true"
                      :overrideReadonly="true"
                      :text="(rform && rform.formData && rform.formData.estadoGestionCobro && rform.formData.estadoGestionCobro.estado) ? $t('facturas.estadoGestionCobroValores.' + rform.formData.estadoGestionCobro.estado) + (rform.formData.estadoGestionCobro.estado === 'OTROS' && rform.formData.estadoGestionCobro.descripcion ? ': ' + rform.formData.estadoGestionCobro.descripcion : '') : ''"
                      :color="getEstadoGestionCobroColor(rform && rform.formData && rform.formData.estadoGestionCobro && rform.formData.estadoGestionCobro.estado ? rform.formData.estadoGestionCobro.estado : null)"
                      :decorationConfig="{
                        icon: 'rectangle_on_rectangle_angled',
                        color: 'blue',
                        tooltip: 'Histórico de estados',
                        action: mostrarHistoricoEstadosGestionCobro
                      }"
                    ></r-input>
                  </div>
                </div>
                <div v-else class="col-100 medium-20">
                  <r-input
                    class="col-100"
                    floating-label
                    :label="$t('facturas.estadoGestionCobro')"
                    :form="rform"
                    type="select"
                    name="estadoGestionCobro.estado"
                    :clearButton="false"
                    @input="onEstadoGestionCobroChange"
                    :decorationConfig="{
                      icon: 'rectangle_on_rectangle_angled',
                      color: 'blue',
                      tooltip: 'Histórico de estados',
                      action: mostrarHistoricoEstadosGestionCobro
                    }"
                  >
                    <option :value="''">-</option>
                    <option :value="'SIN_GESTIONAR'" :style="getEstadoGestionCobroOptionStyle('SIN_GESTIONAR')">{{$t('facturas.estadoGestionCobroValores.SIN_GESTIONAR')}}</option>
                    <option :value="'EN_GESTION_DE_RECLAMACION'" :style="getEstadoGestionCobroOptionStyle('EN_GESTION_DE_RECLAMACION')">{{$t('facturas.estadoGestionCobroValores.EN_GESTION_DE_RECLAMACION')}}</option>
                    <option :value="'COMPROMISO_DE_PAGO'" :style="getEstadoGestionCobroOptionStyle('COMPROMISO_DE_PAGO')">{{$t('facturas.estadoGestionCobroValores.COMPROMISO_DE_PAGO')}}</option>
                    <option :value="'COBRADO_PARCIAL'" :style="getEstadoGestionCobroOptionStyle('COBRADO_PARCIAL')">{{$t('facturas.estadoGestionCobroValores.COBRADO_PARCIAL')}}</option>
                    <option :value="'COBRADO_TOTAL'" :style="getEstadoGestionCobroOptionStyle('COBRADO_TOTAL')">{{$t('facturas.estadoGestionCobroValores.COBRADO_TOTAL')}}</option>
                    <option :value="'EN_CONCURSO_DE_ACREEDORES_EN_ABOGADOS'" :style="getEstadoGestionCobroOptionStyle('EN_CONCURSO_DE_ACREEDORES_EN_ABOGADOS')">{{$t('facturas.estadoGestionCobroValores.EN_CONCURSO_DE_ACREEDORES_EN_ABOGADOS')}}</option>
                    <option :value="'EN_MONITORIO'" :style="getEstadoGestionCobroOptionStyle('EN_MONITORIO')">{{$t('facturas.estadoGestionCobroValores.EN_MONITORIO')}}</option>
                    <option :value="'PENDIENTE_RESPONSABLE_PEDIDO'" :style="getEstadoGestionCobroOptionStyle('PENDIENTE_RESPONSABLE_PEDIDO')">{{$t('facturas.estadoGestionCobroValores.PENDIENTE_RESPONSABLE_PEDIDO')}}</option>
                    <option :value="'EMPRESA_EXTINTA'" :style="getEstadoGestionCobroOptionStyle('EMPRESA_EXTINTA')">{{$t('facturas.estadoGestionCobroValores.EMPRESA_EXTINTA')}}</option>
                    <option :value="'BUROFAX_ENVIADO'" :style="getEstadoGestionCobroOptionStyle('BUROFAX_ENVIADO')">{{$t('facturas.estadoGestionCobroValores.BUROFAX_ENVIADO')}}</option>
                    <option :value="'OTROS'" :style="getEstadoGestionCobroOptionStyle('OTROS')">{{$t('facturas.estadoGestionCobroValores.OTROS')}}</option>
                  </r-input>
                </div>
              </f7-row>
              <!-- Campo de descripción para estado OTROS -->
              <f7-row v-if="rform && rform.formData && rform.formData.estadoGestionCobro && rform.formData.estadoGestionCobro.estado === 'OTROS'">
                <div class="margin-horizontal padding-vertical width-100">
                  <r-input
                    outline
                    floating-label
                    type="text"
                    :label="$t('facturas.descripcionEstadoOtros')"
                    :form="rform"
                    placeholder="Ejemplo: CLIENTE NO CONFORME, PENDIENTE RESPUESTA INTERNA, PENDIENTE ENVÍO DE EXPEDIENTES..."
                    name="estadoGestionCobro.descripcion"
                  />
                </div>
              </f7-row>
            </div>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <pre style="display:none;">{{rform.formData}}</pre>
      <div class="margin-horizontal">
        <f7-segmented raised class="elevation-6 margin-horizontal width-100">
          <f7-button fill tab-link="#tab-lineas" tab-link-active @click="resetTabVisibility()">Líneas</f7-button>
          <f7-button fill tab-link="#tab-direcciones" @click="resetTabVisibility()">Direcciones</f7-button>
          <f7-button fill tab-link="#tab-finanzas" @click="resetTabVisibility()">Pago y Finanzas</f7-button>
          <f7-button fill tab-link="#tab-documentos" @click="resetTabVisibility()">Documentación</f7-button>
          <f7-button v-noroles="['ENAC', 'PRODUCCION']" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.numero" fill tab-link="#tab-tareas" @click="resetTabVisibility(); visibleTabTareas = true">Tareas</f7-button>
          <f7-button v-noroles="['ENAC', 'PRODUCCION']" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.numero" fill tab-link="#tab-oportunidades" @click="resetTabVisibility(); visibleTabOportunidades = true">Oportunidades</f7-button>
          <f7-button fill tab-link="#tab-emails" @click="resetTabVisibility(); visibleTabEmail = true" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.id">e-Mails</f7-button>
        </f7-segmented>
      </div>
      <f7-tabs class="full-height" style="overflow: auto;">
        <f7-tab id="tab-lineas" tab-active>
          <!-- Líneas -->
          <f7-block-title  v-if="$refs.rform && $refs.rform.formData" style="z-index: 30">
            {{$t('pedidos.lineas')}}
          </f7-block-title>

          <div v-if="rform && rform.formData" style="z-index: 30" class="accordion-list">
            <ul class="padding-horizontal">
              <li
                class="accordion-item row margin-vertical border-3"
                :class="{
                  'border-color-blue' : item.tipoLinea == 'TASAS',
                  'border-color-orange' : item.tipoLinea == 'SUBCONTRATACION',
                  'border-color-red' : item.tipoLinea == 'COMISION',
                  'border-color-green' : item.tipoLinea != 'TASAS' && item.tipoLinea != 'SUBCONTRATACION' && item.tipoLinea != 'COMISION',
                  }"
                v-for="(item,index) in rform.formData.lineas"
                :key="'linea-'+index"
              >
              <!-- <a class="col-100 item-content item-link" href="#"> -->
                <div class="item-inner col-100">
                  <f7-card class="no-margin data-linea">
                    <div class="col-100 medium-25 item-content item-input item-input-with-value over-card">
                        <r-badge :color="getColorBadge(item, lineasEjecutable[index])" :text="getTextoBadge(item, lineasEjecutable[index])"></r-badge>
                        <r-badge v-if="(rform.formData && rform.formData.estado && rform.formData.estado.estado == 'CERRADA') || (item.lineStatus && item.lineStatus=='C')" color="gray" text="Línea cerrada"></r-badge>
                        <r-badge v-if="item.origenNum" :color="'teal'" :text="($refs.rform && $refs.rform.formData && $refs.rform.formData.tipo == 'FACTURA' ? 'Pedido: ' : 'Factura: ') + item.origenNum + (item.origenLin !== null && item.origenLin !== undefined ? ' - Línea: ' + item.origenLin : '')"></r-badge>
                        <r-badge v-else-if="item.baseRef" :color="'teal'" :text="($refs.rform && $refs.rform.formData && $refs.rform.formData.tipo == 'FACTURA' ? 'Pedido: ' : 'Factura: ') + item.baseRef + (item.baseLine !== null && item.baseLine !== undefined ? ' - Línea: ' + item.baseLine : '')"></r-badge>
                        <r-badge
                          v-else-if="!readonly && rform.formData.tipo == 'ABONO'"
                          :color="'teal'"
                          :borderColor="'teal'"
                          text="+ factura"
                          style="cursor: pointer;"
                          v-tooltip="'Vincular factura por número'"
                          @click="abrirAsignarFactura(index)"
                        ></r-badge>
                    </div>
                    <f7-list class="list-form">
                      <ul>
                        <f7-row no-gap class="padding-vertical-half first-col">
                          <f7-list-input
                            class="col-100 medium-5"
                            floating-label
                            :label="$t('pedidos.num')"
                            :value="item.numero"
                            v-tooltip="$t('pedidos.num')+' '+item.numero"
                            autocomplete="off"
                            :readonly="true"
                          >
                          </f7-list-input>
                          <!-- <f7-list-input
                            class="col-100 medium-20"
                            floating-label
                            :label="$t('pedidos.item')"
                            :value="item.item ? item.item.nombre : ''"
                            v-tooltip="$t('pedidos.item')+'<br/>'+ (item.item ? item.item.nombre : '')"
                            autocomplete="off"
                            :readonly="true"
                          >
                          </f7-list-input> -->
                          <!-- <f7-list-input
                            class="col-100 medium-40"
                            floating-label
                            :label="$t('pedidos.servicio')"
                            :value="item.servicio ? (item.servicio.userText || item.servicio.nombre) : ''"
                            v-tooltip="$t('pedidos.servicio')+'<br/>'+ (item.servicio ? item.servicio.nombre : '')"
                            autocomplete="off"
                            :readonly="true"
                          >
                          </f7-list-input> -->
                          <f7-list-input
                            class="col-100 medium-40"
                            floating-label
                            label="Concepto"
                            :value="item.text || (item.servicio ? item.servicio.nombre : '')"
                            v-tooltip="item.text || (item.servicio ? item.servicio.nombre : '')"
                            autocomplete="off"
                            :readonly="true"
                          >
                          </f7-list-input>
                          <f7-list-input
                            class="col-100 medium-5"
                            floating-label
                            :label="$t('pedidos.cantidad')"
                            :value="item.cantidad"
                            v-tooltip="$t('pedidos.cantidad')+'<br/>'+item.cantidad"
                            autocomplete="off"
                            :readonly="true"
                          >
                          </f7-list-input>
                          <f7-list-input
                            class="col-100 medium-10 text-color-red"
                            :readonly="true"
                            floating-label
                            :label="$t('pedidos.contratacion')"
                            type="number"
                            step=".01"
                            v-tooltip="$t('pedidos.contratacion')+'<br/>'+totalesLineas[index]['subtotal']"
                            :value="totalesLineas[index]['subtotal']"
                          ></f7-list-input>
                          <f7-list-input
                            class="col-100 medium-10 text-color-red"
                            :readonly="true"
                            v-noroles="['ENAC', 'PRODUCCION']"
                            floating-label
                            :label="$t('pedidos.terceros')"
                            type="number"
                            step=".01"
                            v-tooltip="$t('pedidos.terceros')+'<br/>'+totalesLineas[index]['subtotalTerceros']"
                            :value="totalesLineas[index]['subtotalTerceros']"
                          ></f7-list-input>
                          <f7-list-input
                            class="col-100 medium-10 text-color-red"
                            :readonly="true"
                            floating-label
                            :label="$t('pedidos.totalTasas')"
                            type="number"
                            step=".01"
                            v-tooltip="$t('pedidos.totalTasas')+'<br/>'+totalesLineas[index]['totalTasas']"
                            :value="totalesLineas[index]['totalTasas']"
                          ></f7-list-input>
                          <f7-list-input
                            class="col-100 medium-10 text-color-red"
                            :readonly="true"
                            floating-label
                            :label="$t('pedidos.totalIVA')"
                            type="number"
                            step=".01"
                            v-tooltip="$t('pedidos.totalIVA')+'<br/>'+totalesLineas[index]['ivaConTerceros']"
                            :value="totalesLineas[index]['ivaConTerceros']"
                          ></f7-list-input>
                          <f7-list-input
                            class="col-100 medium-10 text-color-red"
                            :readonly="true"
                            floating-label
                            :label="$t('pedidos.subtotal')"
                            type="number"
                            step=".01"
                            v-tooltip="$t('pedidos.subtotal')+'<br/>'+totalesLineas[index]['totalSinTasasConTercerosSinIVa']"
                            :value="totalesLineas[index]['totalSinTasasConTercerosSinIVa']"
                          ></f7-list-input>
                        </f7-row>
                      </ul>
                    </f7-list>
                    <f7-link
                      v-tooltip="'Editar Línea'"
                      v-if="!readonly"
                      @click="$set($refs.rformNew, 'formData', item);llamarOnBlur2a($refs.rformNew.formData)"
                      class="margin-half link-inline"
                      :class="{'link-inline-1': item.baseEntry||item.origenId, 'link-inline-0': !item.baseEntry&&!item.origenId}"
                      icon-f7="pencil_circle_fill"
                      popup-open=".popupnew"
                    ></f7-link>
                    <f7-link
                      v-if="readonly"
                      v-tooltip="'Ver Línea'"
                      @click="$set($refs.rformNew, 'formData', item);llamarOnBlur2a($refs.rformNew.formData)"
                      class="margin-half link-inline"
                      :class="{'link-inline-1': item.baseEntry||item.origenId, 'link-inline-0': !item.baseEntry&&!item.origenId}"
                      icon-f7="info_circle_fill"
                      popup-open=".popupnew"
                    ></f7-link>
                    <f7-link
                      v-if="item.baseEntry"
                      external
                      v-tooltip="'Ver ' + ($refs.rform && $refs.rform.formData && $refs.rform.formData.tipo == 'FACTURA' ? 'pedido' : 'factura') + ' ' + item.baseRef "
                      class="margin-half link-inline link-inline-0"
                      icon-f7="arrow_up_right_square"
                      color="green"
                      :href="'#!/' + ($refs.rform && $refs.rform.formData && $refs.rform.formData.tipo == 'FACTURA' ? 'pedidos' : 'facturas') + '/view/' + rform.formData.lineasFactura[index].baseId + '/'"
                    ></f7-link>
                    <f7-link
                      v-else-if="item.origenId"
                      external
                      v-tooltip="'Ver ' + ($refs.rform && $refs.rform.formData && $refs.rform.formData.tipo == 'FACTURA' ? 'pedido' : 'factura') + ' ' + item.origenNum "
                      class="margin-half link-inline link-inline-0"
                      icon-f7="arrow_up_right_square"
                      color="green"
                      :href="'#!/' + ($refs.rform && $refs.rform.formData && $refs.rform.formData.tipo == 'FACTURA' ? 'pedidos' : 'facturas') + '/view/' + item.origenId + '/'"
                    ></f7-link>
                    <f7-link
                      v-if="readonly && id && $refs.rform && $refs.rform.formData && $refs.rform.formData.tipo == 'FACTURA' && $refs.rform.formData.numero && getTextoBadge(item, lineasEjecutable[index]) == 'Línea de Servicio'"
                      v-tooltip="'Crear tarea'"
                      class="margin-half link-inline-row-3 link-inline-1"
                      v-noroles="['ENAC', 'PRODUCCION']"
                      icon-f7="calendar_circle"
                      @click="crearTareaLinea(rform.formData.lineasFactura[index])"
                    ></f7-link>
                  </f7-card>
              </div>
              <template v-if="item.comentarios">
                <div v-noroles="['ENAC', 'PRODUCCION']" class="item-inner col-100" 
                  v-for="(texto,index2) in getLineasTexto(item)"
                  :key="'linea-'+index+'texto'+index2">
                  <f7-card class="no-margin linea-texto">
                      {{texto}}
                  </f7-card>
                </div>
              </template>
              <!-- </a> -->
              </li>
            </ul>
          </div>
          <!-- Líneas -->
          <f7-block-title  v-if="$refs.rform && $refs.rform.formData" style="z-index: 30">
            {{$t('pedidos.lineas')}}
          </f7-block-title>
        </f7-tab>
        <f7-tab id="tab-direcciones">
          <f7-card class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <f7-list class="list-form">
                <f7-row>
                  <div class="label-group col-100">Dirección Envío</div>
                  <r-direccion :form="rform" :name="'logistica.direccionEnvio'"></r-direccion>
                  <div class="label-group col-100">Dirección Facturación</div>
                  <r-direccion :form="rform" :name="'logistica.direccionFacturacion'"></r-direccion>
                  <f7-block-title class="col-100">
                    Emails Envío Facturas
                    <f7-link v-if="!readonly" @click="addEmail('emailsFacturas')">{{$t('pedidos.add')}}</f7-link>
                    <f7-link
                      v-if="readonly && rform.formData && rform.formData.cliente && rform.formData.cliente.emailsFacturas && rform.formData.cliente.emailsFacturas.length"
                      external
                      v-tooltip="'Enviar Email'"
                      icon-f7="envelope_badge_fill"
                      :href="'mailto:' + rform.formData.cliente.emailsFacturas.join(';')"
                    ></f7-link>
                  </f7-block-title>
                  <div class="form-caja margin-horizontal" v-if="rform.formData.cliente">
                    <div
                      class="col-100"
                      v-for="(email, index) in rform.formData.cliente.emailsFacturas"
                      :key="'emailFactura-' + index"
                    >
                      <r-input
                        class="col-100"
                        outline
                        floating-label
                        :label="'Correo electrónico'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca un correo electrónico válido'"
                        :name="'cliente.emailsFacturas.' + index"
                        :validation="{isValid: validator.isEmail, errorMessage: '* Introduzca un correo electrónico válido'}"
                      >
                        <f7-link
                          v-if="!readonly"
                          v-tooltip="'Borrar'"
                          slot="inner-end"
                          @click="$delete(rform.formData.cliente.emailsFacturas, index);"
                          class="input-suffix-btn"
                          icon-f7="trash"
                          style="top: initial;right: 15px;"
                        ></f7-link>
                      </r-input>
                    </div>
                  </div>
                  <f7-block-title class="col-100">
                    Emails Envío Informes
                    <f7-link v-if="!readonly" @click="addEmail('emailsCertificados')">{{$t('pedidos.add')}}</f7-link>
                    <f7-link
                      v-if="readonly && rform.formData && rform.formData.cliente && rform.formData.cliente.emailsCertificados && rform.formData.cliente.emailsCertificados.length"
                      external
                      v-tooltip="'Enviar Email'"
                      icon-f7="envelope_badge_fill"
                      :href="'mailto:' + rform.formData.cliente.emailsCertificados.join(';')"
                    ></f7-link>
                  </f7-block-title>
                  <div class="form-caja margin-horizontal" v-if="rform.formData.cliente">
                    <div
                      class="col-100"
                      v-for="(email, index) in rform.formData.cliente.emailsCertificados"
                      :key="'emailCertificado-' + index"
                    >
                      <r-input
                        class="col-100"
                        outline
                        floating-label
                        :label="'Correo electrónico'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca un correo electrónico válido'"
                        :name="'cliente.emailsCertificados.' + index"
                        :validation="{isValid: validator.isEmail, errorMessage: '* Introduzca un correo electrónico válido'}"
                      >
                        <f7-link
                          v-if="!readonly"
                          v-tooltip="'Borrar'"
                          slot="inner-end"
                          @click="$delete(rform.formData.cliente.emailsCertificados, index);"
                          class="input-suffix-btn"
                          icon-f7="trash"
                          style="top: initial;right: 15px;"
                        ></f7-link>
                      </r-input>
                    </div>
                  </div>
                </f7-row>
              </f7-list>
            </f7-card-content>
          </f7-card>
        </f7-tab>
        <f7-tab id="tab-finanzas" v-if="rform.formData && rform.formData.finanzas">
          <tab-finanzas
            ref="tabFinanzas"
            :readonly="readonly"
            :rform="rform" 
          ></tab-finanzas>
        </f7-tab>
        <f7-tab id="tab-documentos">
          <f7-card class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <div v-if="!rform.formData.documentos || !rform.formData.documentos.length">La factura no tiene documentos</div>
              <f7-list class="list-form">
                <ul>
                  <r-files 
                    :form="rform" 
                    name="documentos"
                    :documentoAdapter="Documento"
                  ></r-files>
                </ul>
              </f7-list>
            </f7-card-content>
          </f7-card>
        </f7-tab>
        <f7-tab id="tab-tareas" v-noroles="['ENAC', 'PRODUCCION']" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.numero">
          <r-dynamic-list
            v-if="visibleTabTareas"
            ref="rlist"
            :primary="['id']"
            :dbAdapter="Tarea"
            :tableCode="'TAREASFACTURA'"
            :tableMode="true"
            :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
            class="card full-height data-table"
            classContent="card-content full-height"
            :controlsWidth="100"
            :searchOnInit="true"
            :shownFields="['facturas.codigo']"
            :mandatoryFilter ="{ andList: [{ historificar: true, nombre: 'facturas._id', valor: $refs.rform.formData.id, operacion: 'IN_OBJECT_ID' }] }"
            :funcShowCheck="_ => { return false; }"
            :massiveActions="false"
          >
            <template v-slot:optionsColumn="{ item }">
                <f7-link icon-f7="eye" color="green" @click="popupTareaEditable = false; tareaId = item.id; popupTareasOpened = true"></f7-link>
                <f7-link icon-f7="square_pencil" color="blue" @click="popupTareaEditable = true; tareaId = item.id; popupTareasOpened = true"></f7-link>
                <f7-link icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.id)"></f7-link>
            </template>
          </r-dynamic-list>
        </f7-tab>
        <f7-tab id="tab-oportunidades" v-noroles="['ENAC', 'PRODUCCION']" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.numero">
          <r-dynamic-list
            v-if="visibleTabOportunidades"
            ref="rlistOportunidades"
            :primary="['id']"
            :dbAdapter="Oportunidad"
            :tableCode="'OPORTUNIDAD'"
            :tableMode="true"
            :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
            class="card full-height data-table"
            classContent="card-content full-height"
            :controlsWidth="100"
            :searchOnInit="true"
            :shownFields="['cliente.direcciones']"
            :mandatoryFilter ="{ andList: [{ historificar: true, nombre: 'facturas.codigo', valor: $refs.rform.formData.codigo, operacion: 'EQUALS_IGNORE_CASE' }] }"
            :funcShowCheck="_ => { return false; }"
            :massiveActions="false"
          >
            <template v-slot:optionsColumn="{ item }">
                <f7-link icon-f7="eye" color="green" @click="popupOportunidadEditable = false; oportunidadId = item.id; popupOportunidadesOpened = true"></f7-link>
                <f7-link icon-f7="square_pencil" color="blue" @click="popupOportunidadEditable = true; oportunidadId = item.id; popupOportunidadesOpened = true"></f7-link>
                <f7-link icon-f7="trash" color="red" @click="$refs.rlistOportunidades.deleteItem(item.id)"></f7-link>
            </template>
          </r-dynamic-list>
        </f7-tab>
        <f7-tab id="tab-emails" v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.id">
          <r-dynamic-list
            v-if="visibleTabEmail"
            ref="rlistEmails"
            :primary="['id']"
            :dbAdapter="RegistroEmail"
            :tableCode="'REGISTROEMAILTABS'"
            :tableMode="true"
            :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
            class="card full-height data-table"
            classContent="card-content full-height"
            :controlsWidth="50"
            :searchOnInit="true"
            :shownFields="['to','datos']"
            :mandatoryFilter ="{ historificar: true, andList: [{ historificar: true, nombre: 'datos.idFactura', valor: $refs.rform.formData.id, operacion: 'EQUALS_IGNORE_CASE' }] }"
            :funcShowCheck="_ => { return false; }"
            :massiveActions="false"
            useView="vista_RegistroEmails"
          >
            <template v-slot:optionsColumn="{ item }">
                <f7-link icon-f7="eye" color="green" @click="popupEmailEditable = false; emailId = item.id; popupEmailOpened = true"></f7-link>
            </template>
          </r-dynamic-list>
        </f7-tab>
      </f7-tabs>
    </template>
  </r-form>
  <f7-popup ref="popupnew" class="popupnew" @popup:close="indexLinea = -1; step = 1; if ($refs.rformNew) {$refs.rformNew.clear();} ">
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>
          {{$t('pedidos.linea')}} - {{step}}/{{maxStep}}
        </f7-nav-title>
      </f7-navbar>
      <r-form 
        v-if="clienteSelected"
        ref="rformNew" 
        classContent="full-height"
        @save="onNewLine"
        :readonly="readonly"
      >
        <template v-slot:default="{rform}">
          <div class="display-inline-block text-align-center margin-top">
            <f7-button
              v-if="verBotonAnterior(rform)"
              fill
              color="red"
              class="display-inline-block margin-horizontal"
              @click="step--"
            >{{$t('pedidos.anterior')}}</f7-button>
            <f7-button
              v-if="verBotonSiguiente(rform)"
              fill
              color="primary"
              class="display-inline-block margin-horizontal"
              @click="step++"
            >{{$t('pedidos.siguiente')}}</f7-button>
            <f7-button
              v-if="verBotonGuardar(rform)"
              fill
              color="primary"
              class="display-inline-block margin-horizontal"
              @click="rform.saveItem()"
            >{{$t('pedidos.guardar')}}</f7-button>
            <f7-button
              v-if="verBotonCerrar(rform)"
              fill
              color="primary"
              class="display-inline-block margin-horizontal"
              popup-close=".popupnew"
            >{{$t('pedidos.cerrar')}}</f7-button>
          </div>
          <template v-if="step == 1">
            <div class="list" style="z-index: 4;">
              <ul>
                <r-input
                  v-if="id"
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('pedidos.fechaEjecucion')"
                  :form="rform"
                  type="datepicker"
                  name="camposUsuario.fechaEjecucion"
                  :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                ></r-input>
              </ul>
            </div>
            <f7-block-title>
              {{$t('pedidos.instalacion')}}
              <span
                v-if="!rform.formData.codigoInstalacion"
              >
               - 
              </span>
            </f7-block-title>
            <div class="list" style="z-index: 3;">
              <ul>
                <r-autocomplete
                  key="instalacion"
                  :ref="'instalacion'"
                  :dbAdapter="Instalacion"
                  class="col-100"
                  :form="rform"
                  :name="'codigoInstalacion'"
                  labelProp="nombre"
                  prefixProp="codigo"
                  idProp="codigo"
                  :readonly="true"
                  :overrideReadonly="true"
                  :filter="{clienteId: $refs.rform.formData.cliente ? $refs.rform.formData.cliente.id: null}"
                  @change="$set(rform.formData, 'item', null)"
                >
                </r-autocomplete>
              </ul>
            </div>
            <f7-block-title>
              {{$t('pedidos.item')}}
              <span
                v-if="!readonly && rform.formData.codigoInstalacion && (!rform.formData.item || !rform.formData.item.id)"
              >
               - 
              </span>
            </f7-block-title>
            <div class="list" style="z-index: 2;">
              <ul>
                 <r-autocomplete
                  key="item"
                  :ref="'item'"
                  :dbAdapter="Item"
                  class="col-100"
                  :form="rform"
                  :name="'item'"
                  labelProp="nombre"
                  prefixProp="codigo"
                  :shownFields="['codigo', 'codigoInstalacion', 'direccion', 'administrador', 'instalador', 'mantenedor', 'asociacion']"
                  :readonly="true"
                  :overrideReadonly="true"
                  :filter="{filter: {idCliente: $refs.rform.formData.cliente.id}}"
                  :source="function(self) {
                    return function(query, render) {
                      var results = [];
                      for (var i = 0; i < self.items.length; i++) {
                        if (( self.items[i] && self.items[i][self.searchProp] && self.items[i][self.searchProp].toLowerCase().indexOf(query.toLowerCase()) >= 0 ) && (!rform.formData.codigoInstalacion || rform.formData.codigoInstalacion == self.items[i].codigoInstalacion)) {
                          self.items[i]['txtValue'] = self.items[i]['codigo'] + ' - ' + self.items[i]['nombre'];
                          results.push(self.items[i]);
                        }
                      }
                      render(results);
                    };
                  }"
                  @change="changeItem(rform.formData)"
                  :beforeChange="beforeChangeItem"
                >
                </r-autocomplete>
              </ul>
            </div>
          </template>
          <template v-if="step == 2">
            <f7-block-title>{{$t('pedidos.direccionInspeccion')}}</f7-block-title>
            <div class="list">
              <ul class="row">
                <r-direccion
                  :form="rform"
                  :name="'direccionInspeccion'"
                  :guardarCodigos="true"
                  :readonly="!lineaEditable(rform.formData)"
                  autocomplete="off"
                >
                </r-direccion>
              </ul>
            </div>
            <f7-block-title>{{$t('ofertas.emailComunicaciones')}}</f7-block-title>
            <div class="list">
              <ul class="row">
                <r-input
                  class="col-100 medium-100"
                  floating-label
                  :label="$t('ofertas.emailComunicaciones')"
                  :form="rform"
                  :name="'emailComunicaciones'"
                ></r-input>
              </ul>
            </div>
          </template>
          <template v-if="step == 3">
            <f7-block-title>Concepto</f7-block-title>
            <div class="list" style="z-index: 2;">
              <ul>
                <r-input
                  class="col-100 medium-50"
                  floating-label
                  :label="'Concepto'"
                  :form="rform"
                  :name="'text'"
                ></r-input>
              </ul>
            </div>
            <f7-block-title>{{$t('pedidos.servicio')}}</f7-block-title>
            <div class="list" style="z-index: 2;">
              <ul>
                <r-autocomplete
                  key="servicio"
                  :dbAdapter="Servicio"
                  class="col-100"
                  :form="rform"
                  :name="'servicio'"
                  labelProp="nombre"
                  prefixProp="codigo"
                  :shownFields="['codigo', 'precios', 'tasas', 'tasaDefecto', 'codCuentaMayor', 'tiempoEstimadoCampo', 'tiempoEstimadoOficina', 'materia', 'userText']"
                  @change="changeServicio(rform.formData)"
                  :readonly="true"
                ></r-autocomplete>
              </ul>
            </div>
            <!-- <f7-block-title>{{$t('pedidos.tiempos')}}</f7-block-title>
            <div class="list">
              <ul class="row">
                <r-input
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('pedidos.tiempoEstimadoCampo')"
                  :form="rform"
                  :name="'tiempoEstimadoCampo'"
                  :readonly="!lineaEditable(rform.formData)"
                  type="number"
                ></r-input>
                <r-input
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('pedidos.tiempoEstimadoOficina')"
                  :form="rform"
                  :name="'tiempoEstimadoOficina'"
                  :readonly="!lineaEditable(rform.formData)"
                  type="number"
                ></r-input>
              </ul>
              <ul class="row" v-noroles="['ENAC', 'PRODUCCION']" v-if="rform.formData.tiempoRealCampo || rform.formData.tiempoRealOficina">
                <r-input
                  v-if="rform.formData.tiempoRealCampo"
                  class="col-100 medium-50"
                  floating-label
                  label="Tiempo Real Campo"
                  :form="rform"
                  :name="'tiempoRealCampo'"
                  :readonly="true"
                  :overrideReadonly="true"
                  type="number"
                ></r-input>
                <r-input
                  v-if="rform.formData.tiempoRealOficina"
                  class="col-100 medium-50"
                  floating-label
                  label="Tiempo Real Oficina"
                  :form="rform"
                  :name="'tiempoRealOficina'"
                  :readonly="true"
                  :overrideReadonly="true"
                  type="number"
                ></r-input>
              </ul>
            </div> -->
          </template>
          <template v-if="step == 4">
            <f7-block-title>{{$t('pedidos.importes')}}</f7-block-title>
            <div class="list">
              <ul class="row">
                <r-input
                  class="col-100 medium-33"
                  floating-label
                  :label="$t('pedidos.precio')"
                  :form="rform"
                  :name="'precioUnitario'"
                  type="number"
                  step=".01"
                  :readonly="!lineaEditable(rform.formData)"
                  @change="onBlurPrecioUnitario(rform.formData)"
                ></r-input>
                <r-input
                  class="col-100 medium-33"
                  floating-label
                  :label="$t('pedidos.cantidad')"
                  :form="rform"
                  :name="'cantidad'"
                  type="number"
                  :readonly="!lineaEditable(rform.formData)"
                ></r-input>
                <r-input
                  class="col-100 medium-33"
                  floating-label
                  :label="$t('pedidos.porcDescuento')"
                  :form="rform"
                  :name="'porcDescuento'"
                  type="number"
                  :readonly="!lineaEditable(rform.formData)"
                ></r-input>
                <r-input
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('pedidos.porcSegunda')" 
                  :form="rform"
                  :name="'porcSegunda'"
                  type="number"
                  :readonly="!lineaEditable(rform.formData)"
                  @change="onBlurPorc2a(rform.formData)"
                ></r-input>
                <r-input
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('ofertas.importeSegunda')" 
                  :form="rform"
                  :name="'importeSegunda'"
                  type="number"
                  step=".01"
                  :readonly="!lineaEditable(rform.formData)"
                  @change="onBlurImporte2a(rform.formData)"
                ></r-input>
              </ul>
            </div>
            <f7-block-title>{{$t('pedidos.impuestos')}}</f7-block-title>
            <div class="list">
              <ul class="row">
                <r-input
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('pedidos.tasas')"
                  :form="rform"
                  :name="'tasas'"
                  type="number"
                  :readonly="!lineaEditable(rform.formData)"
                  step=".01"
                ></r-input>
                <r-input
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('pedidos.porcIVA')"
                  :form="rform"
                  :name="'porcIVA'"
                  :readonly="!lineaEditable(rform.formData)"
                  type="number"
                ></r-input>
              </ul>
            </div>
            <f7-block-title class="disabled">{{$t('pedidos.importe')}}</f7-block-title>
            <f7-list>
              <f7-list-input
                class="col-100 medium-25 text-color-red disabled"
                :readonly="true"
                type="number"
                step=".01"
                :value="getTotalesLinea(rform.formData)['total']"
              ></f7-list-input>
            </f7-list>
          </template>
          <!-- <template v-if="step == 5"> -->
            <!-- <p v-roles="['ENAC', 'PRODUCCION']" class="margin-half">Sección en desarrollo</p>
            <f7-block-title v-noroles="['ENAC', 'PRODUCCION']">{{$t('pedidos.colaboradores')}}</f7-block-title>
            <div v-noroles="['ENAC', 'PRODUCCION']" class="list">
              <ul class="row">
                <r-autocomplete
                  :dbAdapter="Cliente"
                  class="col-100"
                  floating-label
                  :label="$t('pedidos.administrador')"
                  :form="rform"
                  :name="'item.administrador'"
                  labelProp="codigoNombre"
                  :idProp="null"
                  idFieldDetail="id"
                  :shownFields="['codigo', 'razonSocial']"
                  :minLength="3"
                  :async="true"
                  :readonly="!lineaEditable(rform.formData)"
                ></r-autocomplete>
                <r-autocomplete
                  :dbAdapter="Cliente"
                  class="col-100"
                  floating-label
                  :label="$t('pedidos.instalador')"
                  :form="rform"
                  :name="'item.instalador'"
                  labelProp="codigoNombre"
                  :idProp="null"
                  idFieldDetail="id"
                  :shownFields="['codigo', 'razonSocial']"
                  :minLength="3"
                  :async="true"
                  :readonly="!lineaEditable(rform.formData)"
                ></r-autocomplete>
                <r-autocomplete
                  :dbAdapter="Cliente"
                  class="col-100"
                  floating-label
                  :label="$t('pedidos.mantenedor')"
                  :form="rform"
                  :name="'item.mantenedor'"
                  labelProp="codigoNombre"
                  :idProp="null"
                  idFieldDetail="id"
                  :shownFields="['codigo', 'razonSocial']"
                  :minLength="3"
                  :async="true"
                  :readonly="!lineaEditable(rform.formData)"
                ></r-autocomplete>
                <r-autocomplete
                  :dbAdapter="Cliente"
                  class="col-100"
                  floating-label
                  :label="$t('pedidos.asociacion')"
                  :form="rform"
                  :name="'item.asociacion'"
                  labelProp="codigoNombre"
                  :idProp="null"
                  idFieldDetail="id"
                  :shownFields="['codigo', 'razonSocial']"
                  :minLength="3"
                  :async="true"
                  :readonly="!lineaEditable(rform.formData)"
                ></r-autocomplete>
              </ul>
            </div> -->
          <!-- </template> -->
          <template v-if="step == 5">
           <p v-roles="['ENAC', 'PRODUCCION']" class="margin-half">Sección en desarrollo</p>
           <div v-noroles="['ENAC', 'PRODUCCION']">
            <f7-block-title>{{$t('pedidos.comision')}}</f7-block-title>
              <div class="list">
                <ul class="row">
                  <r-autocomplete
                    :dbAdapter="Cliente"
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.comision')"
                    :form="rform"
                    :name="'comision.codigo'"
                    labelProp="codigoNombre"
                    idProp="codigo"
                    idFieldDetail="id"
                    :shownFields="['codigo', 'razonSocial']"
                    :minLength="3"
                    :async="true"
                    :readonly="!lineaEditable(rform.formData)"
                  ></r-autocomplete>
                  <r-input
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.codigoOferta')"
                    :form="rform"
                    :readonly="!lineaEditable(rform.formData)"
                    :name="'comision.codigoOferta'"
                  ></r-input>
                  <r-input
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.precio')"
                    :form="rform"
                    type="number"
                    :readonly="!lineaEditable(rform.formData)"
                    step=".01"
                    :name="'comision.precio'"
                  ></r-input>
                  <r-input
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.porcIVA')"
                    :form="rform"
                    type="number"
                    :readonly="!lineaEditable(rform.formData)"
                    :name="'comision.porcIVA'"
                  ></r-input>
                </ul>
              </div>
              <f7-block-title class="disabled">{{$t('pedidos.totalComision')}}</f7-block-title>
              <f7-list>
                <f7-list-input
                  class="col-100 medium-25 text-color-red disabled"
                  :readonly="true"
                  type="number"
                  step=".01"
                  :value="getTotalesLinea(rform.formData)['totalComision']"
                ></f7-list-input>
              </f7-list>
              <f7-block-title>{{$t('pedidos.subcontratacion')}}</f7-block-title>
              <div class="list">
                <ul class="row">
                  <r-autocomplete
                    :dbAdapter="Cliente"
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.proveedor')"
                    :form="rform"
                    :name="'proveedor.codigo'"
                    labelProp="codigoNombre"
                    idProp="codigo"
                    idFieldDetail="id"
                    :shownFields="['codigo', 'razonSocial']"
                    :minLength="3"
                    :async="true"
                    :readonly="!lineaEditable(rform.formData)"
                  ></r-autocomplete>
                  <r-input
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.codigoOferta')"
                    :form="rform"
                    :readonly="!lineaEditable(rform.formData)"
                    :name="'proveedor.codigoOferta'"
                  ></r-input>
                  <r-input
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.precio')"
                    :form="rform"
                    type="number"
                    step=".01"
                    :readonly="!lineaEditable(rform.formData)"
                    :name="'proveedor.precio'"
                  ></r-input>
                  <r-input
                    class="col-100 medium-50"
                    floating-label
                    :label="$t('pedidos.porcIVA')"
                    :form="rform"
                    type="number"
                    :readonly="!lineaEditable(rform.formData)"
                    :name="'proveedor.porcIVA'"
                  ></r-input>
                </ul>
              </div>
              <f7-block-title class="disabled">{{$t('pedidos.totalSubcontratacion')}}</f7-block-title>
              <f7-list>
                <f7-list-input
                  class="col-100 medium-25 text-color-red disabled"
                  :readonly="true"
                  type="number"
                  step=".01"
                  :value="getTotalesLinea(rform.formData)['totalProveedor']"
                ></f7-list-input>
              </f7-list>
            </div>
          </template> 
          <template v-if="step == 6">
            <p v-roles="['ENAC', 'PRODUCCION']" class="margin-half">Sección en desarrollo</p>
            <f7-block-title v-noroles="['ENAC', 'PRODUCCION']">{{$t('pedidos.comentarios')}}</f7-block-title>
            <f7-block-title v-noroles="['ENAC', 'PRODUCCION']">Para que salgan lineas de texto separadas en sap, separar por ##</f7-block-title>
            <div class="list" v-noroles="['ENAC', 'PRODUCCION']">
              <ul class="row">
                <r-input
                  class="col-100"
                  :form="rform"
                  :name="'comentarios'"
                  type="textarea"
                  :readonly="!lineaEditable(rform.formData)"
                ></r-input>
              </ul>
            </div>
          </template>
          <template v-if="step == 7">
            <p v-roles="['ENAC', 'PRODUCCION']" class="margin-half">Sección en desarrollo</p>
            <div v-noroles="['ENAC', 'PRODUCCION']">
              <f7-block-title>{{$t('pedidos.resumen')}}</f7-block-title>
              <f7-block-title class="disabled">{{$t('pedidos.contratacion')}}</f7-block-title>
              <div class="list">
                <ul class="row">
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.subtotal')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['subtotal']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.totalIVA')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['iva']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.total')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['total']"
                  ></f7-list-input>
                </ul>
              </div>
              <f7-block-title class="disabled"></f7-block-title>
              <div class="list">
                <ul class="row">
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.totalTasas')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['totalTasas']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.porcSegunda')"
                    type="number"
                    step=".01"
                    :value="rform.formData.porcSegunda"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.importeSegunda')"
                    type="number"
                    step=".01"
                    :value="rform.formData.importeSegunda"
                  ></f7-list-input>
                  
                </ul>
              </div>
              <f7-block-title class="disabled">{{$t('pedidos.subcontratacion')}}</f7-block-title>
              <div class="list">
                <ul class="row">
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.subtotal')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['subtotalProveedor']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.totalIVA')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['ivaProveedor']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.total')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['totalProveedor']"
                  ></f7-list-input>
                </ul>
              </div>
              <f7-block-title class="disabled">{{$t('pedidos.comision')}}</f7-block-title>
              <div class="list">
                <ul class="row">
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.subtotal')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['subtotalComision']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('pedidos.totalIVA')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['ivaComision']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-33 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('ofertas.total')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['totalComision']"
                  ></f7-list-input>
                </ul>
              </div>
              <f7-block-title class="disabled">{{$t('ofertas.totales')}}</f7-block-title>
              <div class="list">
                <ul class="row">
                  <f7-list-input
                    class="col-100 medium-25 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('ofertas.subtotal')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['subtotalConTerceros']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-25 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('ofertas.totalTasas')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['totalTasas']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-25 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('ofertas.totalIVA')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['ivaConTerceros']"
                  ></f7-list-input>
                  <f7-list-input
                    class="col-100 medium-25 disabled"
                    :readonly="true"
                    floating-label
                    :label="$t('ofertas.total')"
                    type="number"
                    step=".01"
                    :value="getTotalesLinea(rform.formData)['totalConTasasConTerceros']"
                  ></f7-list-input>
                </ul>
              </div>
            </div>
          </template>
          <div class="display-inline-block text-align-center">
            <f7-button
              v-if="verBotonAnterior(rform)"
              fill
              color="red"
              class="display-inline-block margin-horizontal"
              @click="step--"
            >{{$t('pedidos.anterior')}}</f7-button>
            <f7-button
              v-if="verBotonSiguiente(rform)"
              fill
              color="primary"
              class="display-inline-block margin-horizontal"
              @click="step++"
            >{{$t('pedidos.siguiente')}}</f7-button>
            <f7-button
              v-if="verBotonGuardar(rform)"
              fill
              color="primary"
              class="display-inline-block margin-horizontal"
              @click="rform.saveItem()"
            >{{$t('pedidos.guardar')}}</f7-button>
            <f7-button
              v-if="verBotonCerrar(rform)"
              fill
              color="primary"
              class="display-inline-block margin-horizontal"
              popup-close=".popupnew"
            >{{$t('pedidos.cerrar')}}</f7-button>
          </div>
        </template>
      </r-form>
      <f7-popup ref="popupTarea" swipe-to-close :opened="true" v-if="popupTareasOpened" @popup:closed="popupTareasOpened = false; tareaId = null">
        <tarea-form :id="tareaId" linea="" :editable="popupTareaEditable" @close="$refs.popupTarea.close();"  
          :defaultData="{idCliente: $refs.rform.formData.cliente.id, razonSocialCliente: $refs.rform.formData.cliente.razonSocial, codigoCliente: $refs.rform.formData.codCliente, numeroPedido: lineaFactura?lineaFactura.baseDocNum:null, numeroLineaPedido: lineaFactura?lineaFactura.baseLineNum:null, 'facturas.codigo': $refs.rform.formData.codigo, numeroLineaFactura: lineaFactura?lineaFactura.lineNum:null, estado: 'REALIZADA', fechaFecha: new Date(), fechaHora: new Date()}" :esPopup="true"
        ></tarea-form>
      </f7-popup>
    </f7-page>
  </f7-popup>

  <f7-popup ref="popupOportunidad" swipe-to-close :opened="true" v-if="popupOportunidadesOpened" @popup:closed="popupOportunidadesOpened = false; oportunidadId = null">
    <OportunidadForm :objectId="oportunidadId" :editable="popupOportunidadEditable" :facturaid="$refs.rform && $refs.rform.formData ? $refs.rform.formData.id : null" :numeroFactura="$refs.rform && $refs.rform.formData ? $refs.rform.formData.numero : null" @save="popupOportunidadesOpened = false; if ($refs.rlistOportunidades) { $refs.rlistOportunidades.refresh(); }"/>
  </f7-popup>

  <f7-popup ref="popupEmail" swipe-to-close :opened="true" v-if="popupEmailOpened" @popup:closed="popupEmailOpened = false; emailId = null">
    <registro-email-form :id="emailId" :editable="popupEmailEditable" @close="$refs.popupEmail.close();"  
      :defaultData="{ idFactura: $refs.rform.formData.id}" :esPopup="true"
    ></registro-email-form>
  </f7-popup>

  <envio-mail
    v-if="enviarEmail"
    ref="enviarEmail"
    :selected="selectedItems"
    :entityConfig="emailConfigs.factura"
    @email-enviado="enviarEmail = false"
  ></envio-mail>
  
  <!-- Popup de selección de certificados -->
  <!-- Popup de cobros -->
  <f7-popup :opened="popupCobrosOpened" @popup:closed="popupCobrosOpened = false">
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>{{ $t('facturas.cobros') }}</f7-nav-title>
        <f7-nav-right></f7-nav-right>
      </f7-navbar>
      <f7-page-content>
        <div class="list">
          <f7-list>
            <f7-list-item v-if="!hasCobros()">No hay cobros registrados</f7-list-item>
            <f7-list-item v-for="(c, idx) in ($refs.rform && $refs.rform.formData && $refs.rform.formData.cobros ? $refs.rform.formData.cobros : [])" :key="'cobro-'+idx">
              <template #title>
                <div class="row">
                  <div class="col-60">{{ formatDateCobro(c.docDate) }}</div>
                  <div class="col-40 text-align-right">{{ getFormatted(c.docTotal || 0) }}€</div>
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </div>
      </f7-page-content>
    </f7-page>
  </f7-popup>

  <!-- Popup Histórico Estados Gestión Cobro -->
  <f7-popup 
    v-if="popupHistoricoEstadosGestionCobroOpened" 
    :opened="true" 
    @popup:closed="popupHistoricoEstadosGestionCobroOpened = false"
    ref="popupHistoricoEstadosGestionCobro"
    class="popupHistoricoEstados"
  >
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>{{ $t('facturas.historicoEstadosGestionCobro') }}</f7-nav-title>
      </f7-navbar>
      <template>
        <f7-list>
          <!-- Es un registro de auditoría y las columnas dicen lo que son (#188): la del medio no
               es «el usuario» del estado, es QUIEN LO CAMBIÓ. Gemela de la del histórico de
               responsables, que decía «Username». -->
          <f7-row no-gap style="text-align:center;font-weight: bold;" class="list_popup row-header">
            <span class="col-40">{{ $t('facturas.estado') }}</span>
            <span class="col-30">{{ $t('facturas.historicoCambiadoPor') }}</span>
            <span class="col-30">{{ $t('facturas.historicoFechaHora') }}</span>
          </f7-row>
          <f7-row
            no-gap
            v-for="(item, index) in getHistoricoEstadosGestionCobro()"
            :key="'historicoEstadosGestionCobro-' + index"
            :class="'list_popup ' + (index % 2 == 0 ? 'row-even' : 'row-odd')"
          >
            <r-input
              class="col-40"
              type="badge"
              name="estado"
              :readonly="true"
              :overrideReadonly="true"
              :text="(item && item.estado) ? $t('facturas.estadoGestionCobroValores.' + item.estado) + (item.estado === 'OTROS' && item.descripcion ? ': ' + item.descripcion : '') : ''"
              :color="getEstadoGestionCobroColor(item && item.estado ? item.estado : null)"
            ></r-input>
            <f7-list-input
              :value="personaDeHistorico(item.username)"
              v-tooltip="personaDeHistorico(item.username)"
              :readonly="true"
              class="col-30"
              type="text"
            />
            <f7-list-input
              :value="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
              v-tooltip="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
              :readonly="true"
              class="col-30"
              type="text"
            />
          </f7-row>
        </f7-list>
      </template>
    </f7-page>
  </f7-popup>

  <!-- Popup Histórico Responsables Gestión Cobro -->
  <f7-popup 
    v-if="popupHistoricoResponsableGestionCobroOpened" 
    :opened="true" 
    @popup:closed="popupHistoricoResponsableGestionCobroOpened = false"
    ref="popupHistoricoResponsableGestionCobro"
    class="popupHistoricoResponsables"
  >
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>{{ $t('facturas.historicoResponsablesGestionCobro') }}</f7-nav-title>
      </f7-navbar>
      <template>
        <f7-list>
          <!-- LAS COLUMNAS DICEN LO QUE SON (#188). Decía «Responsable | Username | Fecha», y el
               «Username» era en realidad QUIEN HIZO LA ASIGNACIÓN: leído dentro de dos años, se
               entendía que JJCS era el usuario de SMG, que es lo contrario de lo que pone. Es un
               registro de auditoría: quién, a quién y cuándo. -->
          <f7-row no-gap style="text-align:center;font-weight: bold;" class="list_popup row-header">
            <span class="col-40">{{ $t('facturas.historicoResponsableAsignado') }}</span>
            <span class="col-30">{{ $t('facturas.historicoAsignadoPor') }}</span>
            <span class="col-30">{{ $t('facturas.historicoFechaHora') }}</span>
          </f7-row>
          <f7-row
            no-gap
            v-for="(item, index) in getHistoricoResponsablesGestionCobro()"
            :key="'historicoResponsablesGestionCobro-' + index"
            :class="'list_popup ' + (index % 2 == 0 ? 'row-even' : 'row-odd')"
          >
            <f7-list-input
              :value="personaDeHistorico(item.usernameResponsable)"
              v-tooltip="personaDeHistorico(item.usernameResponsable)"
              :readonly="true"
              class="col-40"
              type="text"
            />
            <f7-list-input
              :value="personaDeHistorico(item.username)"
              v-tooltip="personaDeHistorico(item.username)"
              :readonly="true"
              class="col-30"
              type="text"
            />
            <f7-list-input
              :value="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
              v-tooltip="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
              :readonly="true"
              class="col-30"
              type="text"
            />
          </f7-row>
        </f7-list>
      </template>
    </f7-page>
  </f7-popup>

  <f7-popup :opened="mostrarSeleccionCertificados" @popup:closed="mostrarSeleccionCertificados = false" tablet-fullscreen>
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>Seleccionar Certificados</f7-nav-title>
        <f7-nav-right></f7-nav-right>
      </f7-navbar>
      <f7-page-content class="popup-content-certificates">
        <!-- Filtros y controles fijos -->
        <div class="filter-controls-fixed">
          <f7-block class="filter-controls-block">
            <f7-row>
              <f7-col width="75">
                <f7-list form no-hairlines class="filter-list">
                  <f7-list-input
                    label="Filtrar por código, estado, nº factura o cliente"
                    type="text"
                    placeholder="Escriba para filtrar..."
                    :value="filtroTexto"
                    @input="filtrarCertificados"
                    clear-button
                    @input:clear="limpiarFiltro"
                  >
                    <template #media>
                      <f7-icon f7="search" size="18px"></f7-icon>
                    </template>
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col width="25" class="buttons-col-inline">
                <f7-button small fill @click="seleccionarTodosVisibles" class="action-button-icon" v-tooltip="'Seleccionar Todo'">
                  <f7-icon f7="checkmark_alt" size="16px"></f7-icon>
                </f7-button>
                <f7-button small fill color="red" @click="deseleccionarTodosVisibles" class="action-button-icon" v-tooltip="'Deseleccionar Todo'">
                  <f7-icon f7="clear" size="16px"></f7-icon>
                </f7-button>
              </f7-col>
            </f7-row>
          </f7-block>
        </div>
        
        <!-- Lista de certificados con scroll -->
        <div class="certificates-scroll-container">
          <f7-list class="certificates-list">
            <f7-list-item
              v-for="(certificado, index) in certificadosFiltradosComputed"
              :key="`cert-${certificado.id}-${index}`"
              :class="esCertificadoSeleccionado(certificado) ? 'item-selected' : 'item-unselected'"
              @click="toggleCertificadoSeleccion(certificado)"
            >
              <template #media>
                <f7-icon 
                  :f7="esCertificadoSeleccionado(certificado) ? 'checkmark_circle_fill' : 'circle'" 
                  :color="esCertificadoSeleccionado(certificado) ? 'green' : 'gray'"
                ></f7-icon>
              </template>
              
              <!-- Contenido personalizado con cuatro columnas -->
              <template #title>
                <f7-row class="certificate-row">
                  <f7-col width="20" class="certificate-col">
                    <div class="certificate-field">
                      <small class="certificate-label">Nº Factura</small>
                      <div class="certificate-value" v-tooltip="certificado.numeroFactura ? String(certificado.numeroFactura) : 'N/A'">{{ certificado.numeroFactura }}</div>
                    </div>
                  </f7-col>
                  <f7-col width="30" class="certificate-col">
                    <div class="certificate-field">
                      <small class="certificate-label">Código Expediente</small>
                      <div class="certificate-value" v-tooltip="certificado.codigoExpediente || 'N/A'">{{ certificado.codigoExpediente }}</div>
                    </div>
                  </f7-col>
                  <f7-col width="30" class="certificate-col">
                    <div class="certificate-field">
                      <small class="certificate-label">Cliente</small>
                      <div class="certificate-value" v-tooltip="certificado.cliente ? certificado.cliente.razonSocial : 'N/A'">{{ certificado.cliente ? certificado.cliente.razonSocial : 'N/A' }}</div>
                    </div>
                  </f7-col>
                  <f7-col width="10" class="certificate-col">
                    <div class="certificate-field">
                      <small class="certificate-label">Estado</small>
                      <div class="certificate-value" v-tooltip="certificado.estadoExpediente || 'N/A'">{{ certificado.estadoExpediente }}</div>
                    </div>
                  </f7-col>
                  <f7-col width="10" class="certificate-actions">
                    <f7-link icon-f7="eye" color="green" @click.stop="abrirInspeccion(certificado.idExpediente)" v-tooltip="'Ver expediente'" class="certificate-link"></f7-link>
                    <f7-link icon-f7="doc" color="green" @click.stop="descargarCertificado(certificado)" v-tooltip="'Descargar certificado'" class="certificate-link"></f7-link>
                  </f7-col>
                </f7-row>
              </template>
            </f7-list-item>
          </f7-list>
        </div>
        
        <!-- Resumen y botones de acción fijos -->
        <div class="summary-controls-fixed">
          <f7-block class="summary-block">
            <f7-row>
              <f7-col width="33" class="text-align-center">
                <small><strong>Total:</strong> {{ certificados.length }}</small>
              </f7-col>
              <f7-col width="33" class="text-align-center">
                <small><strong>Mostrando:</strong> {{ certificadosFiltradosComputed.length }}</small>
              </f7-col>
              <f7-col width="34" class="text-align-center">
                <small><strong>Seleccionados:</strong> {{ certificadosSeleccionados.length }}</small>
              </f7-col>
            </f7-row>
            
            <f7-button large fill color="blue" @click="confirmarSeleccionCertificados" class="confirm-button">
              <f7-icon f7="checkmark_alt" size="18px"></f7-icon>
              Confirmar Selección ({{ certificadosSeleccionados.length }})
            </f7-button>
          </f7-block>
        </div>
      </f7-page-content>
    </f7-page>
  </f7-popup>

</f7-page>
</template>
<style>

#block_container
{
    display: flex;
}
#block1
{
    margin-left: 20px;
    font-weight: bold
}
#block2
{
    margin-left: 20px;
}

#block3
{
    margin-left: 20px;
}

.linKO
{
 border-style: solid;
 border-color: red;  
 border-radius: 20px;
 margin: 2px;
}
.linOK
{
 border-style: solid;
 border-color: green;  
 border-radius: 20px;
 margin: 2px;
}

.over-card label.disabled {
  opacity: 1 !important;
}
.sub-card label.disabled {
  opacity: 1 !important;
}
.form-caja .item-input-wrap {
  margin-right: 20px;
}
</style>
<style scoped>
.data-linea {
  padding-bottom: 20px;
}
.linea-texto {
  border: 2px solid gray;
  padding-left: 10px;
}
.form-caja {
  min-height: 30px;
  border: 1px solid gray;
  border-radius: var(--f7-input-outline-border-radius);
  padding-bottom: 7px;
}
.form-caja div {
  font-size: 12px;
  color: gray;
}
.menu-item-dropdown .menu-item-content:after {
  content: inherit !important;
}
.over-card {
  position: absolute;
  top: -13px;
  z-index: 3000;
  left: 12px;
  max-width: 90%;
}
.sub-card {
  position: absolute;
  z-index: 3000;
  left: 12px;
  max-width: 90%;
  bottom: 3px;
}
ul.no-padding ul {
  padding: 0 !important;
}
li.accordion-item .card, li.accordion-item .card ul, .border-3, li.accordion-item .accordion-item-content {
  border-radius: 20px;
}
.border-3 {
  border: 3px solid;
}
.label-group {
  margin-top: 12px;
  margin-left: 20px;
  font-weight: bold;
}
.label-group-inspeccion {
  margin-top: 30px;
}
label.btn {
  padding: 1px;
  cursor: pointer;
  border: 1px solid;
}
.link-inline {
  position: absolute;
  top:0;
}
.link-inline-row-2 {
  position: absolute;
  top:25px;
}
.link-inline-row-3 {
  position: absolute;
  top:50px;
}
.link-inline-row-4 {
  position: absolute;
  top:75px;
}
.link-inline-0 {
  right:0;
}
.link-inline-1 {
  right:25px;
}
.link-inline-2 {
  right:50px;
}
.link-inline-3 {
  right:75px;
}
.link-inline-4 {
  right:100px;
}
/* .first-col {
  padding-left: 20px;
}
.first-col:before {
    font-family: 'framework7-core-icons';
    position: absolute;
    top: 50%;
    font-size: 20px;
    color: var(--f7-list-chevron-icon-color);
    pointer-events: none;
    content: var(--f7-accordion-chevron-icon-down);
    margin-top: -4px;
    line-height: 8px;
    transform: translateX(-50%);
    left: calc((var(--f7-list-chevron-icon-area) + var(--f7-list-item-padding-horizontal)) / 2 + var(--f7-safe-area-left));
}
.accordion-item-opened .first-col:before {
    content: var(--f7-accordion-chevron-icon-up);
    width: 14px;
    height: 8px;
    margin-top: -4px;
    line-height: 8px;
} */
</style>
<style scoped>
.tab-link-active .item-media,
.accordion-item-opened .accordion-item-toggle .item-media {
  color: var(--f7-theme-color) !important;
}

.label-radio {
  width: var(--f7-radio-size);
  text-align: center;
}
label.radio.disabled,
label.item-checkbox.disabled {
  opacity: 1 !important;
}
.radio input[type="radio"]:not(:checked) ~ * {
  opacity: 0.2;
}

.page-content::after {
  content: "";
  opacity: 0.5;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}
.list ul {
  background: rgba(255, 255, 255, 0.7);
}

.tab-link-active {
  background-color: var(--f7-theme-color-shade) !important;
}

.accordion-item {
  background-color: #f3f3f3;
}
.accordion-item-content {
  background-color: white;
}

/* Estilos para selección de certificados */
.item-selected {
  background-color: #e8f5e8 !important;
  border-left: 4px solid #4caf50 !important;
}

.item-unselected {
  background-color: #f9f9f9 !important;
  border-left: 4px solid #e0e0e0 !important;
}

/* Estilos para el popup de certificados con scroll controlado */
.popup-content-certificates {
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}

/* Filtros fijos en la parte superior */
.filter-controls-fixed {
  flex-shrink: 0 !important;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.filter-controls-block {
  margin: 8px 0 0 0 !important;
  padding: 10px 15px !important;
  background: transparent !important;
  border: none !important;
}

/* Contenedor con scroll solo para certificados */
.certificates-scroll-container {
  flex: 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  min-height: 0 !important;
}

/* Botones de resumen fijos en la parte inferior */
.summary-controls-fixed {
  flex-shrink: 0 !important;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.filter-list {
  margin: 0 !important;
}

.filter-list .list {
  margin: 0 !important;
  background: transparent !important;
}

.buttons-col-inline {
  display: flex !important;
  flex-direction: row !important;
  gap: 8px !important;
  justify-content: flex-end !important;
  align-items: center !important;
  padding-left: 10px !important;
}

.action-button-icon {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
}

.buttons-col {
  display: flex !important;
  flex-direction: column !important;
  gap: 5px !important;
  padding-left: 10px !important;
}

.action-button {
  height: 32px !important;
  font-size: 12px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 5px !important;
}

.certificates-list {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.summary-block {
  background: transparent !important;
  border: none !important;
  margin: 0 !important;
  padding: 15px !important;
}

.confirm-button {
  margin-top: 10px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
}

/* Estilos para las columnas de certificados */
.certificate-row {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  flex-wrap: nowrap !important;
}

.certificate-col {
  padding: 0 5px !important;
  min-width: 0 !important;
  flex-shrink: 1 !important;
}

.certificate-field {
  text-align: left !important;
  overflow: hidden !important;
}

.certificate-label {
  color: #666 !important;
  font-size: 10px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  margin-bottom: 2px !important;
  display: block !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.certificate-value {
  color: #333 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  word-wrap: break-word !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
/* Estilo para la fila de último cobro: turquesa 50% */
.cobros-row {
  background: rgba(64, 224, 208, 0.5) !important; /* turquesa semitransparente */
  border-radius: 6px;
  padding: 6px 6px;
  margin: 15px 10px 0 15px;
}

.certificate-actions {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 8px !important;
  min-width: 80px !important;
  flex-shrink: 0 !important;
}

.certificate-link {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.1) !important;
  transition: background 0.2s ease !important;
}

.certificate-link:hover {
  background: rgba(255, 255, 255, 0.2) !important;
}

</style>
<script>
import Vue from "vue";
import rForm from "../../components/rForm.vue";
import rInput from "../../components/rInput.vue";
import rBadge from './../../components/rBadge';
import rFiles from "../../components/rFiles.vue";
import rAutocomplete from "../../components/rAutocomplete.vue";
import rAutocompleteM2m from "../../components/rAutocompleteM2m.vue";
import rDireccion from "../../components/rDireccion.vue";
import rCuenta from "../../components/rCuenta.vue";
import rTimepicker from "../../components/rTimepicker.vue";
import tabFinanzas from "../../components/tabFinanzas.vue";
import rDynamicList from "./../../components/rDynamicList.vue";
import Factura from "../../js/db/Factura.js";
import Item from "../../js/db/Item.js";
import Formato from "../../js/db/Formato.js";
import Empleado from "../../js/db/Empleado.js";
import Empresa from "../../js/db/Empresa.js";
import Delegacion from "../../js/db/Delegacion.js";
import CentroTrabajo from "../../js/db/CentroTrabajo.js";
import Departamento from "../../js/db/Departamento.js";
import LineaNegocio from "../../js/db/LineaNegocio.js";
import ListaPrecio from "../../js/db/ListaPrecio.js";
import CondicionPago from "./../../js/db/CondicionPago.js";
import Instalacion from "../../js/db/Instalacion.js";
import Comunidad from "../../js/db/Comunidad.js";
import Servicio from "../../js/db/Servicio.js";
import Cliente from "../../js/db/Cliente.js";
import Tarea from "../../js/db/Tarea.js";
import Inspeccion from "../../js/db/Inspeccion.js";
import validator from "validator";
import ContactoCliente from "../../js/db/ContactoCliente.js";
import Documento from "../../js/db/Documento.js";
import DateUtils from "../../js/DateUtils.js";
import TareaForm from "./../tareas/tarea-form.vue";
import RegistroEmail from "../../js/db/RegistroEmail.js";
import RegistroEmailForm from "./../registroemail/registroemail-form.vue";
import EnvioMail from "../../components/envio-mail.vue";
import { emailConfigs } from "../../js/email-configs.js";
import Utils from "./../../js/Utils.js";
import Property from "../../js/db/Property.js";
import Oportunidad from "../../js/db/Oportunidad.js";
import OportunidadForm from "./../oportunidades/oportunidad-form.vue";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";



export default {
  components: {
    rForm,
    rInput,
    rBadge,
    rTimepicker,
    rFiles,
    rAutocomplete,
    rAutocompleteM2m,
    rDireccion,
    rCuenta,
    tabFinanzas,
    TareaForm,
    rDynamicList,
    RegistroEmailForm,
    EnvioMail,
    OportunidadForm
  },
  data: function() {
    var self = this;
    return {
      DateUtils,
      validator,
      Factura,
      Item,
      Formato,
      Empleado,
      Empresa,
      Delegacion,
      CentroTrabajo,
      Departamento,
      LineaNegocio,
      ListaPrecio,
      CondicionPago,
      Instalacion,
      Comunidad,
      Servicio,
      Cliente,
      ContactoCliente,
      Documento,
      Inspeccion,
      Property,
      readonly: !this.editable,
      idData: null,
      indexLinea: -1,
      step: 1,
      maxStep: 7,
      clienteSelected: false,
      rform: null,
      tipoReparto: null,
      initLineas: [],
      Tarea,
      popupTareasOpened: false,
      popupTareaEditable: false,
      tareaId: null,
      showDetalle: true,
      lineaFactura: null,
      RegistroEmail,
      popupEmailOpened: false,
      popupEmailEditable: false,
      emailId: null,
      visibleTabEmail: false,
      visibleTabTareas: false,
      visibleTabOportunidades: false,
      enviarEmail: false,
      emailConfigs,
      selectedItems: [],
      certificados: [],
      certificadosSeleccionados: [],
      certificadosParaEmail: [],
      filtroTexto: '',
      mostrarSeleccionCertificados: false,
      Utils,
      Oportunidad,
      popupOportunidadesOpened: false,
      popupOportunidadEditable: false,
      oportunidadId: null
      ,
      // Popup para listar cobros
      popupCobrosOpened: false
      ,
      // popups para históricos
      popupHistoricoEstadosGestionCobroOpened: false,
      popupHistoricoResponsableGestionCobroOpened: false,
      /**
       * `username` -> nombre del empleado, para que los históricos de gestión de cobro no enseñen
       * iniciales donde lo que hay es una persona (#188).
       *
       * Se rellena con la lista que YA carga el desplegable de «Responsable Gestión Cobro» de esta
       * misma ficha —su evento `loaded`—, así que no cuesta ninguna petición más. Si esa carga no
       * llega, el mapa se queda vacío y los históricos enseñan el username, que es lo que enseñaban
       * antes: el nombre es un añadido, no un requisito.
       */
      nombresPorUsername: {}
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    totalesLineas: function() {
      var self = this;
      if(!self.$refs.rform || !self.$refs.rform.formData){
        return [];
      }
      return self.$refs.rform.formData.lineas.map(linea => {
        var totales = self.getTotalesLinea(linea);
        return totales;
      });
    },
    lineasEjecutable: function() {
      var self = this;
      if(!self.$refs.rform || !self.$refs.rform.formData){
        return [];
      }
      return self.$refs.rform.formData.lineas.map(linea => {
        var res = true;
        // Debe tener Item
        // if (!linea.item || !linea.item.id) {
        //   res = false;
        // }
        // Debe tener Servicio
        if (!linea.servicio || (!linea.servicio.id && !linea.servicio.codigo)) {
          res = false;
        }
        if (linea.tipoLinea != 'LINEA') {
          res = false;
        }
          return res;
      });
    },

    // Computed property para filtrar certificados de forma reactiva
    certificadosFiltradosComputed() {
      const self = this;
      
      if (!self.certificados || self.certificados.length === 0) {
        return [];
      }
      
      if (!self.filtroTexto || self.filtroTexto === '') {
        return [...self.certificados];
      }
      
      const textoFiltro = self.filtroTexto.toLowerCase();
      
      return self.certificados.filter(certificado => {
        const codigoMatch = (certificado.codigoExpediente || '').toLowerCase().includes(textoFiltro);
        const estadoMatch = (certificado.estadoExpediente || '').toLowerCase().includes(textoFiltro);
        const numeroFacturaMatch = (certificado.numeroFactura ? String(certificado.numeroFactura).toLowerCase() : '').includes(textoFiltro);
        const clienteMatch = (certificado.cliente && certificado.cliente.razonSocial ? certificado.cliente.razonSocial.toLowerCase() : '').includes(textoFiltro);
        
        return codigoMatch || estadoMatch || numeroFacturaMatch || clienteMatch;
      });
    }

  },

  beforeDestroy() {},

  methods: {
    verEnBC: function (bcId) {
      var self = this;
      var app = self.$f7;
      if (!bcId) {
        app.dialog.alert(self.$t('pedidos.bcId_no_disponible') || 'No hay bcId para esta factura.');
        return;
      }
      const baseUrl = process.env.VUE_APP_BC_WEB_URL || process.env.VUE_APP_BC_URL || '';
      if (!baseUrl) {
        app.dialog.alert('Configura VUE_APP_BC_WEB_URL para abrir la factura en Business Central');
        return;
      }
      const environment = process.env.VUE_APP_BC_ENVIRONMENT ? `${process.env.VUE_APP_BC_ENVIRONMENT}/` : '';
      const company = process.env.VUE_APP_BC_COMPANY_ID;
      const companyParam = company ? `company=${encodeURIComponent(company)}` : '';
      const pageParam = 'page=132';
      const filterParam = `filter='$systemId' IS '${encodeURIComponent(bcId)}'`;
      const query = [companyParam, pageParam, filterParam].filter(Boolean).join('&');
      const url = `${baseUrl.replace(/\/$/, '')}/${environment}?${query}`;
      window.open(url, '_blank');
    },
    marcarCobrada() {
      const self = this;
      if (!self.$refs.rform || !self.$refs.rform.formData) {
        self.$f7.dialog.alert('No se pudo acceder a los datos de la factura');
        return;
      }
      const app = self.$f7;
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      
      
      const factura = self.$refs.rform.formData;
      Factura.marcarCobrada({ itemId: factura.id })
        .then(() => {
          espera.cerrar();
          self.$f7.toast.create({
            text: `Factura ${factura.numero || factura.codigo} marcada como cobrada`,
            position: 'center',
            closeTimeout: 3000
          }).open();
          // Recargar datos del formulario
          if (self.$refs.rform && self.$refs.rform.loadItem) {
            self.$refs.rform.loadItem(factura.id);
          }
        })
        .catch(err => {
          espera.cerrar();
          self.$f7.dialog.alert(`Error al marcar la factura como cobrada: ${err.message || err}`);
        });
    },
    resetTabVisibility() {
      this.visibleTabTareas = false;
      this.visibleTabOportunidades = false;
      this.visibleTabEmail = false;
    },

    onEstadoGestionCobroChange(event) {
      const self = this;
      // Inicializar estadoGestionCobro si no existe
      if (!self.$refs.rform.formData.estadoGestionCobro) {
        self.$set(self.$refs.rform.formData, 'estadoGestionCobro', {
          estado: null,
          descripcion: ''
        });
      }
    },

    abrirEnvioEmail(items) {
      const self = this;
      // Preparar items seleccionados
      self.selectedItems = items.map(item => ({ id: item.id }));
      self.enviarEmail = true;
    },

    crearTareaFactura() {
      var self = this;
      if (!self.$refs.rform || !self.$refs.rform.formData) {
        self.$f7.dialog.alert('No se pudo acceder a los datos de la factura');
        return;
      }
      
      const factura = self.$refs.rform.formData;
      
      // Preparar datos de la factura para la tarea
      const facturas = [{
        codigo: factura.codigo,
        numero: factura.numero || factura.numDoc,
        tipo: factura.tipo
      }];
      
      const dataTarea = {
        facturas: facturas,
        estado: 'PENDIENTE',
        importe: factura.saldoVencido || factura.docTotal || 0,
        username: Utils.getUser().username,
        idCliente: factura.cliente ? factura.cliente.id : null,
        razonSocialCliente: factura.cliente ? factura.cliente.razonSocial : '',
        codigoCliente: factura.cliente ? factura.cliente.codigo : ''
      };
      
      const url = `#!/tarea/new/?jsonData=${JSON.stringify(dataTarea)}`;
      window.open(url, '_blank');
      
      // Mostrar toast de confirmación
      self.$f7.toast.create({
        text: `Abriendo formulario de nueva tarea para la factura ${factura.numero || factura.codigo}`,
        position: 'center',
        closeTimeout: 3000
      }).open();
    },

    crearOportunidadFactura() {
      var self = this;
      // TODO De momento solo será una declaración de intenciones, vamos, que esta funcionalidad no hará nada mas que mostrar un mensaje en pantalla.
      self.$f7.dialog.alert('Funcionalidad de creación de oportunidad desde la factura aún no disponible');
      // self.oportunidadId = null;
      // self.popupOportunidadEditable = true;
      // self.popupOportunidadesOpened = true;
    },

    descargarFactura() {
      var self = this;
      if (!self.$refs.rform || !self.$refs.rform.formData) {
        self.$f7.dialog.alert('No se pudo acceder a los datos de la factura');
        return;
      }
      
      const factura = self.$refs.rform.formData;
      if (factura.documentoFactura) {
        window.open(self.Documento.getDocumentoPublicUrl(factura.documentoFactura), "_blank");
      } else {
        self.$f7.dialog.alert('Esta factura no tiene un documento asignado');
      }
    },

    seleccionarDocumentoFactura() {
      var self = this;
      if (!self.$refs.rform || !self.$refs.rform.formData) {
        self.$f7.dialog.alert('No se pudo acceder a los datos de la factura');
        return;
      }
      
      const factura = self.$refs.rform.formData;
      
      // Buscar documentos en la carpeta de facturas para que el usuario pueda seleccionar cual asignar
      Property.getList({filter: {nombre: 'factura.ruta'} }).then(function(res) {
        let ruta = res && res.list && res.list[0]? res.list[0].valor : null;
        if(ruta){
          // con la ruta de las facturas, le añadiremos el filtro de documentos /*_<numDoc>_*.pdf
          ruta = (ruta + '/*_' + factura.numero + '_*.pdf').replace(/\/\//g, '/'); // Aseguramos que no haya dobles barras
          // Llamamos al método ls de Documento para listar los documentos en la ruta especificada
          Documento.ls(ruta)
            .then(res => {
              // si se han encontrado documentos, se los mostramos al usuario para que seleccione uno y al hacer click sobre el que quiere, se asignará.
              if (res && res.list && res.list.length > 0) {
                // Crear Action Sheet con lista de documentos
                const buttons = res.list.map(documento => ({
                  text: `${documento.nombre}.${documento.extension}`,
                  onClick: () => {
                    self.$set(factura, 'documentoFactura', documento);
                    // Asignaremos el documento seleccionado al item
                    Factura.asignaDocumentoFactura({itemId:factura.id,data:factura});
                    self.$f7.toast.create({
                      text: `Documento ${documento.nombre}.${documento.extension} asignado correctamente`,
                      position: 'center',
                      closeTimeout: 2000
                    }).open();
                  }
                }));

                // Añadir botón de cancelar
                buttons.push({
                  text: self.$t('common.cancelar'),
                  color: 'red'
                });

                self.$f7.actions.create({
                  buttons: [
                    // Grupo de documentos
                    buttons.slice(0, -1), // Todos excepto cancelar
                    // Grupo de cancelar
                    [buttons[buttons.length - 1]]
                  ]
                }).open();
              } else {
                self.$f7.dialog.alert(self.$t('facturas.no_documentos_encontrados'));
              }
            })
            .catch(err => {
              console.error(err);
              self.$f7.dialog.alert(self.$t('common.error') + ': ' + (err.message || err));
            });
        } else {
          self.$f7.dialog.alert(self.$t('facturas.ruta_no_configurada'));
        }
      }).catch(function(error) {
        if (error.message) {
          self.$f7.dialog.alert(error.message);
        } else {
          self.$f7.dialog.alert(error);
        }
      });
    },

    crearTareaLinea(linea) {
      const self = this;
      self.$set(self,'lineaFactura', linea);
      self.popupTareaEditable = true; 
      self.popupTareasOpened = true;
    },
    onOpenUrl(url) {
      const self = this;
      window.open(url);
    },
    lineaEditable(linea) {
      const self = this;
      if (self.readonly) {
        return false;
      }
      if (linea.lineStatus && linea.lineStatus == 'O') {
        return true;
      }
      return false;
    },
    getLineaSegundas: function(linea) {
      const self = this;
      if (!linea || !linea.idExpediente) {
        return false;
      }
      return self.$refs.rform.formData.lineas.filter(l => l.idExpedienteRelacionado == linea.idExpediente)[0];
    },
    getNumLineaPrimeras: function (linea) {
      const self = this;
      if (linea.idPedido1as) {
        
        return "Línea de primeras: Pedido: " + linea.numeroPedido1as + " nº " + linea.numeroLinea1as; 
      }
      var codLinea = linea.codigoLinea;

      var parteIzda = codLinea && codLinea.split(".") != null ? codLinea.split(".")[0] : null; 
      var parte2 = parteIzda != null ?  parteIzda.split("-") : null;
      var numLineaPrimeras = parte2 != null ? parte2[1] : null;

      return "Línea de primeras: nº " + ( numLineaPrimeras != null ? numLineaPrimeras : ""); 

    },
    borrarSegundas: function (numeroLinea) {
      var self = this;
      const app = self.$f7;
      app.dialog.confirm(
        "¿Está seguro que quiere eliminar la línea seleccionada?",
        "Advertencia",
        function() {
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          var data = {
            idPedido: self.$refs.rform.formData.id,
            numeroLinea: numeroLinea,
          };
          Factura.borrarSegundas({data: data})
            .then(function(res) {
              self.$refs.rform.formData = res;
              app.toast
              .create({
                icon: '<i class="f7-icons">checkmark</i>',
                text: 'Línea borrada correctamente',
                position: "center",
                destroyOnClose: true,
                closeTimeout: 2000
              })
              .open();
            }).catch(function(e) {
              if (typeof e == "string") {
                e = {
                  message: e
                };
              }
              app.dialog.alert(e.message);
            }).finally(function(e) {
              espera.cerrar();
            });
        }
      );

    },

    getLineasTexto: function(linea) {
      return linea.comentarios.split("##").map(c => c.trim());
    },
    addEmail: function(listName) {
      var self = this;
      var arr = self.$refs.rform.formData.cliente[listName] || [];
      arr.push("");
      self.$set(self.$refs.rform.formData.cliente, listName, arr);
    },
    getMaxNumeroLineas: function(lineas) {
      var maxNumero = -1;
      if (lineas && lineas.length) {
        lineas.forEach(l => {
          if (l.numero > maxNumero) {
            maxNumero = l.numero;
          }
        });
      }
      return maxNumero + 1;
    },
    onBlurPrecioUnitario: function(formData) {
      var self = this;
      self.onBlurPorc2a(formData);
    },
    // --- Cobros helpers ---
    hasCobros() {
      return this.$refs.rform && this.$refs.rform.formData && Array.isArray(this.$refs.rform.formData.cobros) && this.$refs.rform.formData.cobros.length > 0;
    },
    getLastCobro() {
      if (!this.hasCobros()) return null;
      const cobros = this.$refs.rform.formData.cobros.slice().filter(c => c && c.docDate).sort((a,b) => new Date(b.docDate) - new Date(a.docDate));
      return cobros.length ? cobros[0] : null;
    },
    formatDateCobro(fecha) {
      if (!fecha) return '-';
      try {
        const d = new Date(fecha);
        return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
      } catch (e) { return '-'; }
    },
    formatLastCobroFecha() {
      const last = this.getLastCobro();
      return last ? this.formatDateCobro(last.docDate) : '-';
    },
    formatLastCobroImporte() {
      const last = this.getLastCobro();
      return last ? (this.getFormatted(last.docTotal || 0) + '€') : '-';
    },
    llamarOnBlur2a: function (formData) {
      var self = this;
      if (formData.porcSegunda) {
        self.onBlurPorc2a(formData);
      }
      else if (formData.importeSegunda) {
        self.onBlurImporte2a(formData);
      }
    }, 
    onBlurPorc2a: function(formData) {
      var self = this;
      var importeUnitario = formData.precioUnitario;
      var porc2a = formData.porcSegunda;
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
        useGrouping: false
      });
      if (!!importeUnitario && importeUnitario > 0 && !!porc2a && porc2a > 0) {
        self.$set(formData, "importeSegunda", formatter.format((importeUnitario / 100) * porc2a));
      } else {
        self.$set(formData, "importeSegunda", 0);
      }
    },
    onBlurImporte2a: function(formData) {
      var self = this;
      var importeUnitario = formData.precioUnitario;
      var importe2a = formData.importeSegunda;
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
        useGrouping: false
      });
      if (!!importe2a && importe2a > 0 && !!importeUnitario && importeUnitario > 0) {
        self.$set(formData, "porcSegunda", formatter.format((importe2a * 100) / importeUnitario));
      } else {
        self.$set(formData, "porcSegunda", 0);
      }
    },
    abrirAsignarFactura: function(index) {
      var self = this;
      self.$f7.dialog.prompt('Nº de la factura a vincular', 'Vincular factura', function(valor) {
        valor = (valor || '').trim();
        if (!/^\d+$/.test(valor)) {
          self.$f7.dialog.alert('Introduce solo el número de la factura (sin letras).');
          return;
        }
        var linea = self.$refs.rform.formData.lineas[index];
        // Solo se informa origenNum: el backend resuelve la factura por número al guardar.
        self.$set(linea, 'origenNum', valor);
      });
    },
    onNewLine: function(nuevaLinea) {
      const self = this;
      if (self.$refs.rform.formData.lineas.filter(l => l.numero == nuevaLinea.numero).length) {
          var linea = self.$refs.rform.formData.lineas.filter(l => l.numero == nuevaLinea.numero)[0];
          self.$set(self.$refs.rform.formData.lineas, self.$refs.rform.formData.lineas.indexOf(linea), nuevaLinea);
      } else {
        self.$refs.rform.formData.lineas.push(nuevaLinea);
      }
      if (self.$refs.popupnew) {
        self.$refs.popupnew.close();
      }
    },
    verBotonSiguiente: function(rform) {
      const self = this;

      if (self.step >= self.maxStep || !rform || !rform.formData) {
        return false;
      }
      if (self.readonly) {
        return true;
      }
      if (self.step == 1) {
        return true;
      }
      if (self.step == 2) {
        return true;
      }
      if (self.step == 3) {
        return rform.formData.servicio && rform.formData.servicio.id;
      }

      return true;
    },
    verBotonAnterior: function(rform) {
      const self = this;

      if (self.step <= 1 || !rform || !rform.formData) {
        return false;
      }
      if (self.step == 3) {
        return !rform.formData.firma;
      }

      return true;
    },
    verBotonGuardar: function(rform) {
      const self = this;

      return self.lineaEditable(rform.formData);
    },
    verBotonCerrar: function(rform) {
      const self = this;

      return self.step == self.maxStep && rform && !self.lineaEditable(rform.formData);
    },
    planificar: function(lineas, idPedido) {
      var self = this;
      var app = self.$f7;
      var jsonData = [{
        idPedido: idPedido,
        numeroLineas: lineas.filter((linea, idx) => linea.tipoLinea && linea.tipoLinea != 'TASAS' && linea.tipoLinea != 'SUBCONTRATACION' && linea.tipoLinea != 'COMISION' && linea.estado && (linea.estado.estado == 'CREADO_PEDIDO' || linea.estado.estado == 'PLANIFICADA') && self.lineasEjecutable[idx]).map(linea => linea.numero)
      }]
      app.views.current.router.navigate(
        "/pedidos/planificar/?jsonData=" + JSON.stringify(jsonData)
      );
    },
    beforeSaveItem: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var formData = data;
      formData.clienteId = self.$refs.rform.formData.cliente.id;
      formData.codigoInstalacion = self.$refs.rformNew.formData.codigoInstalacion;
      resolve(formData);
    },
    onSaveItem: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$refs.rformItem.clear();
      if (self.$refs.popupItem) {
        self.$refs.popupItem.close();
      }
      if (Array.isArray(self.$refs.item)) {
        self.$refs.item.forEach(i => i.reload());
      } else if (self.$refs.item) {
        self.$refs.item.reload();
      }
      if (self.$refs.rformNew && self.$refs.rformNew.formData) {
        self.$set(self.$refs.rformNew.formData, 'item', res);
      }
      app.toast
        .create({
          text: self.$t("ofertas.item_creado"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    beforeSaveInstalacion: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var formData = data;
      formData.clienteId = self.$refs.rform.formData.cliente.id;
      resolve(formData);
    },
    onSaveInstalacion: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$refs.rformInstalacion.clear();
      if (self.$refs.popupInstalacion) {
        self.$refs.popupInstalacion.close();
      }
      if (Array.isArray(self.$refs.instalacion)) {
        self.$refs.instalacion.forEach(i => i.reload());
      } else if (self.$refs.instalacion) {
        self.$refs.instalacion.reload();
      }
      if (self.$refs.rformNew && self.$refs.rformNew.formData) {
        self.$set(self.$refs.rformNew.formData, 'codigoInstalacion', res.codigo);
      }
      app.toast
        .create({
          text: self.$t("ofertas.instalacion_creada"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    getFormatted(importe) {
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
        useGrouping: false
      });
      return formatter.format(importe);
    },
    getTotalesPedido: function(lineas) {
      var self = this;
      var totales = {
        descuento: 0,
        totalSinDto: 0,
        subtotal: 0,
        iva: 0,
        totalTasas: 0,
        total: 0,
        subtotalProveedor: 0,
        ivaProveedor: 0,
        totalProveedor: 0,

        subtotalComision: 0,
        ivaComision: 0,
        totalComision: 0,

        subtotalTerceros: 0,
        ivaTerceros: 0,
        totalTerceros: 0,

        subtotalConTerceros: 0,
        ivaConTerceros: 0,
        totalConTerceros: 0,
        totalConTasasConTerceros: 0,
        totalSinTasasConTercerosSinIVa: 0,
        // importeAplicado: 0,
        // saldoVencido: 0
      };
      if(!lineas || lineas.length <= 0) {
        return totales;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
        useGrouping: false
      });
      lineas.forEach(linea => {
        var totalesLinea = self.getTotalesLinea(linea);
        for (const t in totales) {
          totales[t] = formatter.format(parseFloat(totales[t]) + parseFloat(totalesLinea[t]));
        }
      });
      return totales;
    },
    getTotalesLinea: function(linea) {
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
        useGrouping: false
      });
      var cantidad = linea.cantidad;
      var dtoUnitario = linea.precioUnitario / 100 * linea.porcDescuento;
      var descuento = dtoUnitario * cantidad;
      var totalSinDto = linea.precioUnitario * cantidad;
      var totalTasas = linea.tasas * cantidad;
      var subtotal = totalSinDto - descuento;
      var iva = subtotal / 100 * linea.porcIVA;
      var total = subtotal + iva;
      
      // Proveedor
      var proveedor = linea.proveedor || {precio: 0, porcIVA: 21};
      var subtotalProveedor = proveedor.precio * cantidad;
      var ivaProveedor = subtotalProveedor / 100 * proveedor.porcIVA;
      var totalProveedor = subtotalProveedor + ivaProveedor;
      // Comision
      var comision = linea.comision || {precio: 0, porcIVA: 21};
      var subtotalComision = comision.precio * cantidad;
      var ivaComision = subtotalComision / 100 * comision.porcIVA;
      var totalComision = subtotalComision + ivaComision;

      var subtotalTerceros = subtotalProveedor + subtotalComision;
      var ivaTerceros = ivaProveedor + ivaComision;
      var totalTerceros = totalProveedor + totalComision;


      var totales = {
        descuento: formatter.format(descuento),
        totalSinDto: formatter.format(totalSinDto),
        subtotal: formatter.format(subtotal),
        iva: formatter.format(iva),
        totalTasas: formatter.format(totalTasas),
        total: formatter.format(total),
        subtotalProveedor: formatter.format(subtotalProveedor),
        ivaProveedor: formatter.format(ivaProveedor),
        totalProveedor: formatter.format(totalProveedor),

        subtotalComision: formatter.format(subtotalComision),
        ivaComision: formatter.format(ivaComision),
        totalComision: formatter.format(totalComision),

        subtotalTerceros: formatter.format(subtotalTerceros),
        ivaTerceros: formatter.format(ivaTerceros),
        totalTerceros: formatter.format(totalTerceros),

        subtotalConTerceros: formatter.format(subtotal + subtotalProveedor + subtotalComision  ),
        ivaConTerceros: formatter.format(iva + ivaProveedor + ivaComision),
        totalConTerceros: formatter.format(total + totalProveedor + totalComision),
        totalConTasasConTerceros: formatter.format(total + totalProveedor + totalComision + totalTasas),
        totalSinTasasConTercerosSinIVa: formatter.format(total + totalProveedor + totalComision - iva - ivaProveedor - ivaComision),

        importeAplicado: formatter.format(linea.importeAplicado),
        // saldoVencido: formatter.format(linea.saldoVencido)
      };
      
      return totales;
    },
    beforeSave: function(data, resolve, reject) {
      var self = this;
      var factura = self.$refs.rform.formData;
      var app = self.$f7;
      for (const idx in data.lineas) {
        var linea = data.lineas[idx];
        linea.importe = self.totalesLineas[idx]["subtotal"];
      }
      resolve(data);
    },
    changeContacto: function() {
      var self = this;
      var app = self.$f7;
      var contactocliente = self.$refs.contactoCliente.selected;
      if (contactocliente && contactocliente.canalesComunicacion) {
        contactocliente.canalesComunicacion.filter(canal=>canal.tipo == "EMAIL").forEach(canal => {
          self.$set(self.$refs.rform.formData, 'emailContacto', canal.valor);
        });
      }
    },
    changeServicio: function(linea) {
      var self = this;
      if (!linea.precioUnitario && linea.servicio) {
        var precio = undefined;
        if (linea.servicio.precios && linea.servicio.precios.length > 0) {
          var listaPrecios = self.$refs.cliente.selected
            ? self.$refs.cliente.selected.listaPrecios
            : undefined;
          if (listaPrecios) {
            precio = linea.servicio.precios.filter(
              s => s.listaPrecios == listaPrecios
            )[0];
          }
          if (!precio) {
            precio = linea.servicio.precios[0];
          }
        }
        if (precio) {
          self.$set(
            linea,
            "precioUnitario",
            precio.precioUnidad
          );
        }
      }
      if (!linea.tasas && linea.servicio) {
        var tasa = undefined;
        if (linea.servicio.tasas && linea.servicio.tasas.length > 0) {
          
          var provincia = linea.direccionInspeccion ? linea.direccionInspeccion.provincia : undefined;
          if (provincia) {
            var tasaDTO = linea.servicio.tasas.filter(s => s.provincia == provincia)[0];
            tasa = tasaDTO ? tasaDTO.valor : undefined;
          }
          if (!tasa) {
            tasa = linea.servicio.tasaDefecto;
          }
        } else {
          tasa = linea.servicio.tasaDefecto;
        }
        if (tasa) {
          self.$set(linea, 'tasas', tasa);
        }
      }
      if (
        !linea.tiempoEstimadoCampo &&
        linea.servicio &&
        linea.servicio.tiempoEstimadoCampo
      ) {
        self.$set(
          linea,
          "tiempoEstimadoCampo",
          linea.servicio.tiempoEstimadoCampo
        );
      }
      if (
        !linea.tiempoEstimadoOficina &&
        linea.servicio &&
        linea.servicio.tiempoEstimadoOficina
      ) {
        self.$set(
          linea,
          "tiempoEstimadoOficina",
          linea.servicio.tiempoEstimadoOficina
        );
      }
      if (
        !linea.codCuentaMayor &&
        linea.servicio &&
        linea.servicio.codCuentaMayor
      ) {
        self.$set(
          linea,
          "codCuentaMayor",
          linea.servicio.codCuentaMayor
        );
      }
    },
    beforeChangeItem: function (itemNuevo) {
      var self = this;
      var itemViejo = self.$refs.rformNew.formData.item;
      if (typeof itemViejo != 'undefined' && itemViejo != null){
        itemViejo.codigo = null;
        itemViejo.nombre = null;
        itemViejo.codInstalacion = null;
        itemViejo.id = null;
        itemNuevo = Object.assign({}, itemViejo, itemNuevo);
      }
      return itemNuevo;

    },
    changeItem: function(linea) {
      var self = this;
      if (!linea.direccionInspeccion && linea.item && linea.item.direccion) {
          self.$set(self.$refs.rformNew.formData, 'direccionInspeccion', linea.item.direccion);
      }
      if (!linea.codigoInstalacion && linea.item && linea.item.codigoInstalacion) {
          self.$set(self.$refs.rformNew.formData, 'codigoInstalacion', linea.item.codigoInstalacion);
      }
    },
    loadItem: function(res) {
      const self = this;
      self.$set(self.$refs.rform, "formData", res);
      if (!res.lineas || res.lineas == null) {
        self.$set(self.$refs.rform.formData, "lineas", []);
      } else {
        self.$set(self.$refs.rform.formData, "lineas", self.getSortedLineas(res.lineas));
      }

      // cargamos las finanzas, aunque si metemos todo el res al formData no lo veo necesario.
      if(!res.finanzas) {
        self.$set(self.$refs.rform.formData, "finanzas", {});
      } 

      self.initLineas = JSON.parse(JSON.stringify(res.lineas));

      self.clienteSelected = res.cliente && res.cliente.id;
      //self.initDatosFinanzas(res.finanzas.codCondicionesPago);
      if (!res.inspectores || res.inspectores == null) {
        self.$set(self.$refs.rform.formData, "inspectores", []);
      }
      // if (res.cliente) {
      //   self.changeCliente();
      // }
    },
    getSortedLineas: function(lineas) {
      var compare = function (a, b) {
        if (!a.estado || !a.estado.estado) {
          return -1;
        }
        if (!b.estado || !b.estado.estado) {
          return 1;
        }
        if (a.estado.estado == b.estado.estado) {
          return a.numero < b.numero ? -1 : 1; 
        }
        if (a.estado.estado == "CREADA_OFERTA") {
          return -1;
        }
        return 1;
      }
      return lineas.sort(compare);
    },
    cancelarFactura: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("facturas.pregunta_cancelar"),
        "Eliminar",
        function() {
          Factura.cancelar({ itemId: self.id })
            .then(function(res) {
              if (res) {
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
                self.$f7router.back();
              }
            })
            .catch(function(error) {
              app.dialog.alert(error.message);
            });
        }
      );
    },
    deleteItem: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          Factura.delete({ itemId: self.id })
            .then(function(res) {
              if (res) {
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
                self.$f7router.back();
              }
            })
            .catch(function(error) {
              app.dialog.alert(error.message);
            });
        }
      );
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$set(self.$refs.rform, "formData", res);
      // self.$refs.tabFinanzas.initDatosFinanzas(res.finanzas.codCondicionesPago);     
      self.idData = res.id;
      self.readonly = true;
      app.toast
        .create({
          text: self.$t("facturas.guardado_ok"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    filterViasPago: function(autocomplete){
      var self = this;
      return function(query, render) {
        var results = autocomplete.items.filter(item => self.condicionesPagoActivas.some(condicion => condicion.viaPago.codigo == item.codigo))
          .map(condicion => {
            condicion['txtValue'] = condicion[autocomplete.searchProp];
            return condicion;
          });
        render(results);
      };
    },
    filterCondicionesCuentas: function(autocomplete){
      var self = this;
      return function(query, render) {
        var options = self.condicionesPagoActivas.filter(condicion => self.getCondicionesPagoPosibles().some(condicionPosible => condicionPosible.id == condicion.id && condicion.cuenta))
          .map(condicion => {
            if(condicion["cuenta"] != undefined){
              condicion['txtValue'] = ""+condicion["cuenta"].trim();
            }
            return condicion;
          });
        options.sort((a,b) => a.cuenta > b.cuenta ? 1 : -1);
        var results = [];
        options.forEach(option => {
          if(!results.some(result => result.txtValue == option.txtValue) && option.txtValue){
            results.push(option);
          }
        });

        render(results);
      };
    },
    filterCondicionesPlazos: function(autocomplete){
      var self = this;
      return function(query, render) {
        var options = self.condicionesPagoActivas.filter(condicion => self.getCondicionesPagoPosibles().some(condicionPosible => condicionPosible.id == condicion.id && condicion.plazoDias != undefined ))
          .map(condicion => {
            if(condicion["plazoDias"] != undefined){
              condicion['txtValue'] = ""+condicion["plazoDias"];
            }
            return condicion;
          });
        options.sort((a,b) => a.plazoDias > b.plazoDias ? 1 : -1);
        var results = [];
        options.forEach(option => {
          if(!results.some(result => result.txtValue == option.txtValue) && option.txtValue){
            results.push(option);
          }
        });

        render(results);
      };
    },
    getTextoBadge: function(linea, lineaEjecutable) {

      if (linea.tipoLinea == 'TASAS') {
        return "Línea de tasas";
      }
      else if (linea.tipoLinea == 'SUBCONTRATACION') {
        return "Línea de subcontratación";
      }
      else if (linea.tipoLinea == 'COMISION') {
        return "Línea de comisión";
      }
      else if (linea.servicio && linea.servicio.codigo){
        return "Línea de Servicio";
      } else {
        return "Línea sin servicio";
      }
      
    },
    getColorBadge: function(linea, lineaEjecutable) {

      if (linea.tipoLinea == 'TASAS') {
        return "blue";
      } else if (linea.tipoLinea == 'SUBCONTRATACION') {
        return "orange";
      } else if (linea.tipoLinea == 'COMISION') {
        return "red";
      } else {
        return "green";
      }
      
    },
    // Devuelve el color para el estado de gestión de cobro basado en el mapping de ListadoFacturas.json
    getEstadoGestionCobroColor: function(estado) {
      if (!estado) return 'gray';
      const map = {
        'SIN_GESTIONAR': 'gray',
        'EN_GESTION_DE_RECLAMACION': 'orange',
        'COMPROMISO_DE_PAGO': 'yellow',
        'COBRADO_PARCIAL': 'lightblue',
        'COBRADO_TOTAL': 'green',
        'EN_CONCURSO_DE_ACREEDORES_EN_ABOGADOS': 'purple',
        'EN_MONITORIO': 'blue',
        'PENDIENTE_RESPONSABLE_PEDIDO': 'pink',
        'EMPRESA_EXTINTA': 'darkred',
        'BUROFAX_ENVIADO': 'teal',
        'OTROS': 'brown'
      };
      return map[estado] || 'gray';
    },
    // Devuelve un style inline para usar en las <option> del select (background + color de texto)
    getEstadoGestionCobroOptionStyle: function(estado) {
      if (!estado) return '';
      const bgMap = {
        'SIN_GESTIONAR': 'gray',
        'EN_GESTION_DE_RECLAMACION': 'orange',
        'COMPROMISO_DE_PAGO': 'yellow',
        'COBRADO_PARCIAL': 'lightblue',
        'COBRADO_TOTAL': 'green',
        'EN_CONCURSO_DE_ACREEDORES_EN_ABOGADOS': 'purple',
        'EN_MONITORIO': 'blue',
        'PENDIENTE_RESPONSABLE_PEDIDO': 'pink',
        'EMPRESA_EXTINTA': 'darkred',
        'BUROFAX_ENVIADO': 'teal',
        'OTROS': 'brown'
      };
      const bg = bgMap[estado] || 'gray';
      // contraste simple: para fondos claros usar texto negro, para fondos oscuros usar blanco
      const darkBackgrounds = ['gray','blue','purple','green','orange','darkred','teal','brown'];
      const color = darkBackgrounds.includes(bg) ? '#fff' : '#000';
      return `background:${bg}; color:${color};`;
    },

    seleccionarCertificados() {
      const self = this;
      
      // Obtener el ID de la factura actual
      const idFactura = self.$refs.rform.formData.id;
      
      if (!idFactura) {
        self.$f7.dialog.alert('No se ha encontrado el ID de la factura');
        return;
      }
      
      // Mostrar loading
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      
      self.$f7.toast.create({
        text: `Se buscarán todos los certificados de la factura, esto puede llevar su tiempo.`,
        position: 'center',
        closeTimeout: 3000
      }).open();
      
      Factura.certificadosPorFacturas([idFactura])
        .then(response => {
          console.log('📋 Certificados recibidos del backend:', response);
          
          // Añadir campo selected a cada certificado
          const certificadosConSeleccion = response.map(cert => ({
            ...cert,
            selected: true
          }));
          
          // Guardar los certificados en el campo data
          self.certificados = certificadosConSeleccion;
          self.certificadosSeleccionados = [];
          self.filtroTexto = '';
          
          console.log('✅ Certificados procesados con campo selected:', self.certificados);
          
          // Mostrar popup de selección de certificados
          self.mostrarSeleccionCertificados = true;
        })
        .catch(error => {
          console.error('Error al seleccionar certificados:', error);
          self.$f7.dialog.alert(`Error al obtener certificados: ${error.message}`);
        })
        .finally(() => {
          // Ocultar loading
          espera.cerrar();
        });
    },
    
    // Métodos para la selección de certificados
    filtrarCertificados(e) {
      const self = this;
      const textoFiltro = e.target.value;
      console.log('🔍 Filtrando certificados con texto:', textoFiltro);
      
      // Solo actualizar el valor del filtro, el computed se encarga del resto
      self.filtroTexto = textoFiltro;
      
      console.log(`📊 Certificados que coinciden: ${self.certificadosFiltradosComputed.length} de ${self.certificados.length}`);
    },
    
    limpiarFiltro() {
      const self = this;
      console.log('🧹 Limpiando filtro de certificados');
      
      // Solo resetear el filtro, el computed se encarga del resto
      self.filtroTexto = '';
      
      console.log('✅ Filtro limpiado. Mostrando todos los certificados:', self.certificadosFiltradosComputed.length);
    },
    
    esCertificadoSeleccionado(certificado) {
      console.log(`🔍 Verificando selección para certificado ${certificado.id}:`, certificado.selected);
      return certificado.selected === true;
    },
    
    toggleCertificadoSeleccion(certificado) {
      const self = this;
      console.log(`🎯 Click en certificado ${certificado.id}, estado actual:`, certificado.selected);
      
      // Cambiar el estado selected del certificado
      self.$set(certificado, 'selected', !certificado.selected);
      
      console.log(`✅ Nuevo estado para certificado ${certificado.id}:`, certificado.selected);
      
      // Actualizar array de seleccionados para estadísticas
      self.actualizarCertificadosSeleccionados();
    },
    
    actualizarCertificadosSeleccionados() {
      const self = this;
      // Filtrar todos los certificados que están marcados como selected
      self.certificadosSeleccionados = self.certificados.filter(cert => cert.selected === true);
      console.log(`📊 Certificados seleccionados actualizados: ${self.certificadosSeleccionados.length}`, self.certificadosSeleccionados.map(c => c.id));
    },
    
    seleccionarTodosVisibles() {
      const self = this;
      console.log('🎯 Seleccionando todos los certificados visibles...');
      console.log('📋 Certificados visibles:', self.certificadosFiltradosComputed.map(c => c.id));
      
      self.certificadosFiltradosComputed.forEach(certificado => {
        if (!certificado.selected) {
          console.log(`✅ Seleccionando certificado ${certificado.id}`);
          self.$set(certificado, 'selected', true);
        }
      });
      
      self.actualizarCertificadosSeleccionados();
    },
    
    deseleccionarTodosVisibles() {
      const self = this;
      console.log('🎯 Deseleccionando todos los certificados visibles...');
      console.log('📋 Certificados visibles:', self.certificadosFiltradosComputed.map(c => c.id));
      
      self.certificadosFiltradosComputed.forEach(certificado => {
        if (certificado.selected) {
          console.log(`❌ Deseleccionando certificado ${certificado.id}`);
          self.$set(certificado, 'selected', false);
        }
      });
      
      self.actualizarCertificadosSeleccionados();
    },
    
    confirmarSeleccionCertificados() {
      const self = this;
      
      console.log('🔍 Confirmando selección...');
      console.log('📊 Certificados seleccionados:', self.certificadosSeleccionados.length);
      console.log('📋 Lista de certificados seleccionados:', self.certificadosSeleccionados);
      
      if (self.certificadosSeleccionados.length === 0) {
        console.log('❌ No hay certificados seleccionados');
        self.$f7.dialog.alert('Debe seleccionar al menos un certificado');
        return;
      }
      
      // Guardar los certificados seleccionados para uso posterior
      self.certificadosParaEmail = self.certificadosSeleccionados.map(cert => ({...cert}));
      
      // Añadir "Certificado" al campo documentosAAdjuntar del formulario de email si existe
      self.agregarCertificadoAEmail();
      
      // Cerrar el popup
      self.mostrarSeleccionCertificados = false;

      // Añadir certificados a los elementos seleccionados
      self.selectedItems.forEach(item => {
        item.certificados = self.certificadosParaEmail.filter(cert => cert.idFactura === item.id);
      });

      // Mostrar toast de confirmación
      self.$f7.toast.create({
        text: `Se seleccionaron ${self.certificadosSeleccionados.length} certificados y se añadió "Certificado" a los documentos a adjuntar`,
        position: 'center',
        closeTimeout: 3000
      }).open();
      
      console.log('✅ Selección confirmada:', self.certificadosSeleccionados);
    },
    
    agregarCertificadoAEmail() {
      const self = this;
      // Intentar acceder al componente de envío de email
      const envioMailComponent = self.$refs.enviarEmail;
      
      if (envioMailComponent && envioMailComponent.$refs.rformEnviarEmail) {
        const rform = envioMailComponent.$refs.rformEnviarEmail;
        
        if (rform.formData) {
          console.log('📧 Añadiendo "Certificado" al formulario de email');
          
          // Inicializar documentosAAdjuntar si no existe
          if (!rform.formData.documentosAAdjuntar) {
            self.$set(rform.formData, 'documentosAAdjuntar', []);
          }
          
          // Verificar si "Certificado" ya está en la lista
          const yaExiste = rform.formData.documentosAAdjuntar.includes('Certificado');
          
          if (!yaExiste) {
            rform.formData.documentosAAdjuntar.push('Certificado');
            console.log('✅ "Certificado" añadido a documentosAAdjuntar');
          } else {
            console.log('ℹ️ "Certificado" ya estaba en documentosAAdjuntar');
          }
        }
      } else {
        console.log('⚠️ No se pudo acceder al componente de envío de email o su formulario');
      }
    },

    abrirInspeccion(idExpediente) {
      const url = `?#!/inspecciones/view/${idExpediente}/`;
      window.open(url, '_blank');
    },
    
    descargarCertificado(certificado, beta = false){
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      let inspeccion = {
        id: certificado.idExpediente,
        codigo: certificado.codigoExpediente,
        cliente: certificado.cliente,
      };
      Inspeccion.descargarCertificado(inspeccion, beta)
        .catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          if(e.message) {
            app.dialog.alert(e.message);
          } else {
            var e = JSON.parse(new TextDecoder().decode(new Uint8Array(e.response)));
            if (e &&  e.error && e.error.code == 'ERROR_AUDITORIA') {
              var message = e.error.message + " :<ul>";
              e.error.errors.forEach( err => {message+= "<li>"+err+"</li>";})
              message+="</ul>";
              app.dialog.alert(message + " <br> ");
            } else {
            var msg = e.error.message;
            app.dialog.alert(msg);
            }
          } 
        }).finally(function(e) {
          espera.cerrar();
        });
    },

    // Históricos de Estados y Responsables Gestión Cobro
    getHistoricoEstadosGestionCobro: function () {
      const self = this;
      // devolvemos solo el historico (el estado actual ya está incluido automáticamente)
      return self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.historicoEstadosGestionCobro ? self.$refs.rform.formData.historicoEstadosGestionCobro : [];
    },
    mostrarHistoricoEstadosGestionCobro: function () {
      const self = this;
      self.popupHistoricoEstadosGestionCobroOpened = true;
    },
    getHistoricoResponsablesGestionCobro: function () {
      const self = this;
      // devolvemos solo el historico (el responsable actual ya está incluido automáticamente)
      return self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.historicoResponsableGestionCobro ? self.$refs.rform.formData.historicoResponsableGestionCobro : [];
    },
    mostrarHistoricoResponsablesGestionCobro: function () {
      const self = this;
      self.popupHistoricoResponsableGestionCobroOpened = true;
    },
    /**
     * Se queda con los nombres de los empleados que acaba de cargar el desplegable de «Responsable
     * Gestión Cobro», indexados por username (#188).
     *
     * Es la lista de ese desplegable y no una petición nueva: el autocompletado no es `async`, así
     * que al abrir la ficha ya trae `username` y `nombre` de todos los empleados con una proyección
     * corta. Lo único que hace falta es no tirarla.
     */
    guardarNombresEmpleados: function (lista) {
      const self = this;
      const mapa = {};
      (lista || []).forEach(function (empleado) {
        if (empleado && empleado.username) {
          mapa[String(empleado.username).trim().toUpperCase()] = empleado.nombre;
        }
      });
      self.nombresPorUsername = mapa;
    },
    /**
     * Cómo se escribe una persona en los históricos de gestión de cobro: **nombre y username**,
     * `Nombre Apellidos (SMG)`.
     *
     * Los dos y no uno: el nombre es lo que se entiende leyendo el histórico dentro de dos años
     * —«SMG» no dice quién es—, y el username es con lo que se puede cruzar el apunte con la
     * consulta de Facturas y con la bandeja de asignación, así que tampoco se puede quitar.
     *
     * Si el empleado ya no está en la lista —se dio de baja, o el apunte es de alguien que ya no
     * existe— se enseña el username tal cual. No se inventa un nombre ni se oculta el apunte: es un
     * registro de auditoría y lo que se guardó se enseña.
     *
     * La comparación es sin mayúsculas ni espacios, igual que la de la API: el mismo username está
     * escrito de dos maneras en los datos y por eso la bandeja ofrecía dos veces a la misma persona.
     */
    personaDeHistorico: function (username) {
      const self = this;
      if (username === null || username === undefined || String(username).trim() === '') {
        return '';
      }
      const limpio = String(username).trim();
      const nombre = self.nombresPorUsername[limpio.toUpperCase()];
      return nombre ? nombre + ' (' + limpio + ')' : limpio;
    }

  },
  created: function() {
    var self = this;
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    self.idData = self.id;
    CondicionPago.getList({filter:{activa:true}}).then(function(res){
      self.condicionesPagoActivas = res.list;
    });
    
    // Configurar emailConfigs para facturas añadiendo la acción de selección de certificados
    if (emailConfigs.factura && emailConfigs.factura.documentosOpciones) {
      emailConfigs.factura.documentosOpciones.forEach(opcion => {
        if(opcion.name === 'Certificado'){
          opcion.action = self.seleccionarCertificados;
        }
      });
    }
    // if(self.$refs.rform && self.$refs.rform.formData && !self.$refs.rform.formData.finanzas) {
    //   self.$set(self.$refs.rform.formData, "finanzas", {});
    // }
  }
};
</script>
